export const termsData = [
  // --- 株式投資 ---
  {
    id: 1,
    term: '株式',
    category: '株式投資',
    description: '株式会社が事業を行うための資金を集めるために発行する証券のことです。株式を保有する人を「株主」と呼び、株主は会社の利益の一部を配当金として受け取ったり、会社の経営方針を決める株主総会で議決権を行使したりする権利を持ちます。',
    relatedTerms: ['株主', '配当金', '株主優待', '株価', '証券取引所']
  },
  {
    id: 2,
    term: '現物取引',
    category: '株式投資',
    description: '投資家が自分自身が保有している資金の範囲内で株式などを売買する、最も基本的な取引方法です。購入した株式や売却代金は、通常、取引が成立した日（約定日）から起算して2営業日後に受け渡されます。',
    relatedTerms: ['信用取引', '自己資金', '約定日', '受渡日', '証券口座']
  },
  {
    id: 3,
    term: '信用取引',
    category: '株式投資',
    description: '証券会社に一定の担保（委託保証金）を預けることで、自己資金以上の金額の取引を行ったり、保有していない株式を借りて売却（空売り）したりすることができる取引方法です。大きなリターンを狙える可能性がある一方、リスクも高くなります。',
    relatedTerms: ['現物取引', 'レバレッジ', '空売り', '委託保証金', '追証']
  },
  {
    id: 4,
    term: '単元株',
    category: '株式投資',
    description: '日本の株式市場で、株式を売買する際の基本的な取引単位のことです。多くの企業では1単元を100株としており、株主総会での議決権は通常1単元以上の保有で与えられます。',
    relatedTerms: ['ミニ株', 'S株', '株式分割', '議決権', '売買単位']
  },
  {
    id: 5,
    term: 'ミニ株',
    category: '株式投資',
    description: '単元株よりも少ない単位（例えば1株や10株）から株式を売買できる制度の通称です。証券会社によって「S株」「単元未満株」など呼び方が異なります。少額から投資を始められるメリットがあります。',
    relatedTerms: ['単元株', 'S株', '単元未満株', '株式ミニ投資', '少額投資']
  },
  {
    id: 6,
    term: '株主優待',
    category: '株式投資',
    description: '企業が株主に対して、自社製品、サービス利用券、割引券、クオカードなどを提供する制度です。企業が株主への感謝のしるしとして行うもので、日本独自の制度として個人投資家に人気があります。',
    relatedTerms: ['株式', '配当金', '権利確定日', '株主', '個人投資家']
  },
  {
    id: 7,
    term: '配当金',
    category: '株式投資',
    description: '企業が事業活動によって得た利益の一部を、株主に対してその保有株数に応じて分配するお金のことです。年に1回または2回（中間配当・期末配当として）支払われることが一般的です。インカムゲインの一つです。',
    relatedTerms: ['株式', '株主', '配当利回り', 'インカムゲイン', '権利確定日', '無配']
  },
  {
    id: 8,
    term: 'IPO',
    category: '株式投資',
    description: '「新規株式公開」または「新規上場」のことです。これまで証券取引所に上場していなかった企業が、新たに株式を公開し、一般の投資家が市場で売買できるようにすることです。企業にとっては資金調達の手段となります。',
    relatedTerms: ['PO', '上場', '未上場株', '公募価格', '初値', 'ブックビルディング']
  },
  {
    id: 9,
    term: 'PO',
    category: '株式投資',
    description: '「公募」と訳され、既に上場している企業が新たに株式を発行して資金調達を行う「公募増資（Primary Offering）」や、既存の大株主などが保有する株式を市場に売り出す「売出し（Secondary Offering）」などを指します。',
    relatedTerms: ['IPO', '増資', '売出し', '希薄化', '資金調達', '時価発行']
  },
  {
    id: 10,
    term: 'TOB',
    category: '株式投資',
    description: '「株式公開買付け」のことです。ある株式会社の経営権の取得などを目的に、買付者（企業や個人）が買付期間、買付価格、買付予定株数などを公告し、不特定多数の株主から市場外で株式を買い集める手法です。',
    relatedTerms: ['M&A', '買収', '経営権', '友好的TOB', '敵対的TOB', 'ホワイトナイト']
  },
  {
    id: 11,
    term: 'MBO',
    category: '株式投資',
    description: '「経営陣買収」のことです。会社の経営陣が、自社の株式を既存の株主（親会社やオーナー、一般株主など）から買い取り、自らその会社のオーナー経営者となる行為を指します。事業再編や非公開化による意思決定の迅速化などを目的として行われることがあります。',
    relatedTerms: ['EBO', 'TOB', 'LBO', '非公開化', '事業承継']
  },
  {
    id: 12,
    term: 'EBO',
    category: '株式投資',
    description: '「従業員買収」のことです。会社の従業員が、自社の株式を既存の株主や経営者から買い取り、経営権を取得する行為を指します。事業承継の手段としてや、従業員の経営参加意識を高める目的で行われることがあります。',
    relatedTerms: ['MBO', '事業承継', '従業員持株会', 'ESOP']
  },
  {
    id: 13,
    term: '株式分割',
    category: '株式投資',
    description: '発行済みの1株を複数の株式に分割することです。例えば1株を2株に分割すると、株主の保有株数は2倍になり、1株あたりの株価は理論上半分になります。株価を引き下げて最低投資金額を小さくし、株式の流動性を高めることなどが目的です。',
    relatedTerms: ['株式併合', '単元株', '株価', '流動性', '投資単位']
  },
  {
    id: 14,
    term: '株式併合',
    category: '株式投資',
    description: '複数の株式を1株に統合することです。例えば5株を1株に併合すると、株主の保有株数は5分の1になり、1株あたりの株価は理論上5倍になります。株価水準の適正化（低位株からの脱却）や、管理コストの削減などを目的として行われることがあります。',
    relatedTerms: ['株式分割', '株価', '発行済株式数', '単元未満株', 'スクイーズアウト']
  },
  {
    id: 15,
    term: '議決権',
    category: '株式投資',
    description: '株主が株主総会に出席し、会社の重要事項（取締役の選任、定款の変更、合併など）に関する議案に対して、賛成または反対の意思を表示する権利のことです。原則として、1単元株（通常100株）につき1つの議決権が与えられます。',
    relatedTerms: ['株主総会', '単元株', '会社法', '株主の権利', '普通株式', '種類株式']
  },
  {
    id: 16,
    term: '株主総会',
    category: '株式投資',
    description: '株式会社の最高意思決定機関であり、株主によって構成されます。会社の基本的な方針や重要事項（決算の承認、取締役・監査役の選任、配当金の決定など）について報告を受け、決議を行います。年に一度開催される「定時株主総会」と、必要に応じて開催される「臨時株主総会」があります。',
    relatedTerms: ['議決権', '株主', '取締役会', '決算承認', '配当決定', '委任状']
  },
  {
    id: 17,
    term: 'ストップ高',
    category: '株式投資',
    description: '株式市場において、株価が1日のうちに上昇できる上限の値段のことです。過度な株価の変動を抑え、市場の混乱を防ぐために、各銘柄ごとに前日の終値を基準とした値幅制限が設けられており、その上限価格に達した状態を指します。',
    relatedTerms: ['ストップ安', '値幅制限', '特別気配', 'サーキットブレーカー制度', '比例配分']
  },
  {
    id: 18,
    term: 'ストップ安',
    category: '株式投資',
    description: '株式市場において、株価が1日のうちに下落できる下限の値段のことです。ストップ高と同様に、過度な株価変動を抑制するための値幅制限によるもので、その下限価格に達した状態を指します。',
    relatedTerms: ['ストップ高', '値幅制限', '特別気配', 'サーキットブレーカー制度', '比例配分']
  },
  {
    id: 19,
    term: '気配値',
    category: '株式投資',
    description: '株式などの金融商品を売買する際に、市場で提示されている売り注文の値段（売り気配）と買い注文の値段（買い気配）のことです。まだ売買が成立していない段階での価格情報で、投資家はこれを見て注文の判断をします。',
    relatedTerms: ['板', '売り気配', '買い気配', '成行注文', '指値注文', '約定値段']
  },
  {
    id: 20,
    term: '板',
    category: '株式投資',
    description: '証券取引所などで、ある銘柄に対する現在の売り注文と買い注文の状況を価格帯別に一覧表示したものです。「気配値情報」とも呼ばれます。どの価格にどれくらいの注文量があるか（「板が厚い」「板が薄い」などと表現される）が分かり、需給の強弱を判断する材料の一つになります。',
    relatedTerms: ['気配値', '買い板', '売り板', '指値注文', '出来高', '歩み値', '需給バランス']
  },

  // --- 投資信託 ---
  {
    id: 21,
    term: '投資信託',
    category: '投資信託',
    description: '多くの投資家から集めた資金を一つにまとめ、運用の専門家（ファンドマネージャー）が株式や債券、不動産などに分散して投資・運用し、その運用成果を投資額に応じて投資家に還元する金融商品です。少額から手軽に分散投資を始められるのが特徴です。「ファンド」とほぼ同義で使われます。',
    relatedTerms: ['ファンド', '分散投資', 'ファンドマネージャー', '基準価額', '信託報酬', 'ポートフォリオ']
  },
  {
    id: 22,
    term: 'ファンド',
    category: '投資信託',
    description: '特定の目的のために集められた資金、またはその資金を運用する仕組みのことです。投資の世界では、一般的に「投資信託」とほぼ同じ意味で使われます。様々な種類のファンドがあり、投資対象や運用方針によって分類されます。',
    relatedTerms: ['投資信託', '運用会社', 'ポートフォリオ', '私募ファンド', '公募ファンド']
  },
  {
    id: 23,
    term: 'インデックスファンド',
    category: '投資信託',
    description: '特定の株価指数（例：日経平均株価、TOPIX、S&P500など）に連動する運用成果を目指す投資信託のことです。市場全体の平均的な動きを目指すため「パッシブ運用」とも呼ばれます。一般的に、アクティブファンドに比べて信託報酬が低い傾向にあります。',
    relatedTerms: ['アクティブファンド', '株価指数', 'ベンチマーク', 'パッシブ運用', 'TOPIX', 'S&P500', '信託報酬']
  },
  {
    id: 24,
    term: 'アクティブファンド',
    category: '投資信託',
    description: '特定の株価指数（ベンチマーク）を上回る運用成果を目指す投資信託のことです。ファンドマネージャーが独自の調査や分析に基づいて投資銘柄を選定し、積極的に運用戦略を実行します。インデックスファンドに比べて信託報酬が高い傾向にあります。',
    relatedTerms: ['インデックスファンド', 'ファンドマネージャー', 'ベンチマーク', '超過収益', 'アルファ', '信託報酬']
  },
  {
    id: 25,
    term: 'ETF',
    category: '投資信託',
    description: '「上場投資信託」の略称です。特定の株価指数や商品価格などに連動するように運用される投資信託の一種で、証券取引所に上場しているため、株式と同様に取引時間中リアルタイムで売買が可能です。',
    relatedTerms: ['投資信託', '上場', '株式', 'インデックス運用', 'マーケットメイク', 'リアルタイム取引']
  },
  {
    id: 26,
    term: 'J-REIT',
    category: '投資信託',
    description: '日本の不動産投資信託のことです。投資家から集めた資金でオフィスビルや商業施設、マンションなどの不動産に投資し、そこから得られる賃料収入や売却益を投資家に分配します。証券取引所に上場しており、ETFと同様に売買できます。',
    relatedTerms: ['REIT', '不動産投資', '投資法人', '分配金', 'NAV倍率']
  },
  {
    id: 27,
    term: '基準価額',
    category: '投資信託',
    description: '投資信託の値段のことで、1口または1万口あたりの純資産額を示します。投資信託に組み入れられている株式や債券などの資産を時価評価し、そこから運用にかかる費用（信託報酬など）を差し引いた純資産総額を、総口数で割って算出されます。通常1日に1回公表されます。',
    relatedTerms: ['投資信託', '純資産総額', '時価評価', '信託報酬', 'NAV', '販売手数料']
  },
  {
    id: 28,
    term: '分配金',
    category: '投資信託',
    description: '投資信託の運用によって得られた収益の一部を、決算時に投資家（受益者）に還元するお金のことです。投資信託の運用方針や収益状況によって、分配金の有無や金額は変動します。株式の配当金に似ていますが、元本の一部を取り崩して支払われる場合もあります（特別分配金）。',
    relatedTerms: ['投資信託', '収益分配金', '普通分配金', '特別分配金', '決算日', '再投資']
  },
  {
    id: 29,
    term: '信託報酬',
    category: '投資信託',
    description: '投資信託を運用・管理してもらうための費用のことです。投資信託を保有している間、信託財産の中から日々差し引かれます。「運用管理費用」とも呼ばれます。通常、純資産総額に対して年率◯％という形で表示されます。',
    relatedTerms: ['投資信託', '運用コスト', '販売手数料', '信託財産留保額', '目論見書', '隠れコスト']
  },
  {
    id: 30,
    term: 'ノーロードファンド',
    category: '投資信託',
    description: '購入時に販売手数料がかからない投資信託のことです。「ロード」とは販売手数料を指します。投資家は購入時のコストを抑えることができますが、信託報酬やその他の費用は別途かかる点に注意が必要です。',
    relatedTerms: ['販売手数料', '投資信託', '信託報酬', '購入時手数料', 'フロントロード']
  },
  {
    id: 31,
    term: 'ブル型ファンド',
    category: '投資信託',
    description: '相場の上昇局面で、対象となる株価指数などの値動きの数倍（例えば2倍や3倍）の収益を目指す投資信託です。「ブル」は強気相場を意味します。相場が予想通りに上昇すれば大きなリターンが期待できますが、下落した場合は損失も数倍になるハイリスク・ハイリターンな商品です。',
    relatedTerms: ['ベア型ファンド', 'レバレッジ型ファンド', '強気相場', 'デリバティブ', 'ハイリスク・ハイリターン']
  },
  {
    id: 32,
    term: 'ベア型ファンド',
    category: '投資信託',
    description: '相場の下落局面で、対象となる株価指数などの値動きの数倍（例えば-1倍や-2倍）の収益を目指す投資信託です。「ベア」は弱気相場を意味します。「インバース型ファンド」とも呼ばれます。相場が下落すると利益が出ますが、上昇した場合は損失が発生します。',
    relatedTerms: ['ブル型ファンド', 'インバース型ファンド', '弱気相場', 'デリバティブ', '空売り効果']
  },
  {
    id: 33,
    term: 'テーマ型ファンド',
    category: '投資信託',
    description: '特定のテーマ（例：AI、ESG、再生可能エネルギー、ヘルスケアなど）に関連する企業の株式などに投資する投資信託です。成長が期待される分野に集中投資できますが、テーマの将来性や市場動向に運用成果が大きく左右される可能性があります。',
    relatedTerms: ['投資信託', 'セクターファンド', 'ESG投資', 'AI関連株', '集中投資']
  },
  {
    id: 34,
    term: 'バランス型ファンド',
    category: '投資信託',
    description: '国内外の株式、債券、不動産（REIT）など、複数の異なる種類の資産に分散して投資する投資信託です。一つのファンドで手軽に資産の組み合わせ（ポートフォリオ）を構築でき、リスク分散効果が期待できます。資産配分の比率はファンドごとに異なります。',
    relatedTerms: ['投資信託', '分散投資', 'ポートフォリオ', 'アセットアロケーション', 'リスク許容度']
  },
  {
    id: 35,
    term: '積立投資',
    category: '投資信託',
    description: '毎月一定額など、定期的に決まった金額で同じ投資信託や株式などを継続して買い付けていく投資方法です。購入タイミングを分散することで、価格変動リスクを抑える効果（ドルコスト平均法）が期待できます。長期的な資産形成に適した手法の一つとされています。',
    relatedTerms: ['ドルコスト平均法', '定期購入', '時間分散', '長期投資', 'NISA (つみたて投資枠)', '複利効果']
  },

  // --- 債券 ---
  {
    id: 36,
    term: '債券',
    category: '債券',
    description: '国や地方公共団体、企業などが、投資家から比較的長期の資金を借り入れる際に発行する有価証券です。満期（償還日）まで保有すれば額面金額が戻ってくるほか、多くの場合、定期的に利子（クーポン）が支払われます。一般的に株式よりリスクが低いとされています。',
    relatedTerms: ['国債', '社債', '利付債', '割引債', '償還日', '額面金額', 'クーポンレート', '格付け', '利回り']
  },
  {
    id: 37,
    term: '国債',
    category: '債券',
    description: '国が発行する債券のことです。国の公共事業や政策実施などのための財政資金を調達する目的で発行されます。利払いや元本の償還は国によって保証されるため、一般的に発行される債券の中で最も信用度が高く、安全性が高い金融商品とされています。',
    relatedTerms: ['債券', '地方債', '社債', '財務省', '個人向け国債', '新窓販国債', '安全資産']
  },
  {
    id: 38,
    term: '地方債',
    category: '債券',
    description: '都道府県や市町村などの地方公共団体が発行する債券のことです。道路や学校、水道などの公共施設の整備や運営に必要な資金を調達するために発行されます。国債に次いで信用度が高いとされています。',
    relatedTerms: ['債券', '国債', '社債', '地方公共団体', '住民参加型地方債']
  },
  {
    id: 39,
    term: '社債',
    category: '債券',
    description: '民間の事業会社が発行する債券のことです。設備投資や運転資金、M&A資金など、事業活動に必要な資金を調達するために発行されます。発行体の信用力（財務状況や収益力など）によって利率やリスクの度合いが異なり、格付けが投資判断の重要な参考になります。',
    relatedTerms: ['債券', '国債', '格付け', '信用リスク', '普通社債', '転換社債型新株予約権付社債', '劣後債']
  },
  {
    id: 40,
    term: '利付債',
    category: '債券',
    description: '額面金額に対して一定の利率が定められており、満期（償還日）までの間、定期的に利子（クーポン）が支払われる債券のことです。多くの債券はこのタイプに該当します。利子の支払い頻度は、半年ごとや年1回など様々です。',
    relatedTerms: ['割引債', 'クーポン', 'クーポンレート', '利率', '債券', 'インカムゲイン', '固定利付債', '変動利付債']
  },
  {
    id: 41,
    term: '割引債',
    category: '債券',
    description: '利子（クーポン）が支払われない代わりに、額面金額よりも割り引かれた価格で発行され、満期時に額面金額で償還される債券のことです。「ゼロクーポン債」とも呼ばれます。購入価格と額面金額との差額（償還差益）が投資家の利益となります。',
    relatedTerms: ['利付債', 'ゼロクーポン債', '償還差益', '額面金額', 'ディスカウント債', 'ストリップス債']
  },
  {
    id: 42,
    term: '格付け',
    category: '債券',
    description: '債券の発行体（国や企業など）の信用力や、個別の債券の元本および利息の支払いの確実性を評価し、アルファベットや記号（例：AAA、AA、A、BBBなど）で表示したものです。ムーディーズ、S&P、フィッチなどの格付会社が付与します。投資家が債券の信用リスクを判断する際の重要な指標となります。',
    relatedTerms: ['信用リスク', '格付会社', 'ジャンク債 (ハイイールド債)', '投資適格債', 'デフォルト (債務不履行)', 'ソブリン格付け']
  },
  {
    id: 43,
    term: '利回り',
    category: '債券',
    description: '投資した金額に対して得られる収益の年間割合のことです。債券の場合、購入価格、額面金額、表面利率（クーポンレート）、償還までの残存期間などから算出されます。代表的なものに、新発債を購入し満期まで保有した場合の「応募者利回り」、既発債を購入し満期まで保有した場合の「最終利回り」などがあります。',
    relatedTerms: ['クーポンレート', '利率', '債券価格', '最終利回り', '応募者利回り', '直接利回り', '所有期間利回り']
  },
  {
    id: 44,
    term: '既発債',
    category: '債券',
    description: '既に発行された後、投資家の間で売買（流通）されている債券のことです。証券会社などを通じて、時価で購入・売却することができます。価格は市場の需給関係や金利水準の変動などによって日々変わります。',
    relatedTerms: ['新発債', '流通市場 (セカンダリーマーケット)', '債券価格', '時価', '金利変動リスク']
  },
  {
    id: 45,
    term: '新発債',
    category: '債券',
    description: '新たに発行される債券のことです。発行市場（プライマリーマーケット）において、発行条件（利率、償還期間、発行価格など）が決定され、投資家に販売（募集・売出し）されます。購入できる期間や金額に制限がある場合があります。',
    relatedTerms: ['既発債', '発行市場 (プライマリーマーケット)', '起債', '応募者利回り', '発行価格', '募集期間']
  },

  // --- FX・為替 ---
  {
    id: 46,
    term: 'FX',
    category: 'FX・為替',
    description: '「外国為替証拠金取引」の略称です。異なる2国間の通貨を売買し、その価格変動（為替差益）や、2通貨間の金利差から得られる利益（スワップポイント）を狙う金融商品です。少ない資金（証拠金）で大きな金額の取引ができる「レバレッジ効果」が特徴です。',
    relatedTerms: ['為替レート', '証拠金', 'レバレッジ', 'スワップポイント', '通貨ペア', '為替差益']
  },
  {
    id: 47,
    term: '為替レート',
    category: 'FX・為替',
    description: 'ある国の通貨と別の国の通貨を交換する際の交換比率（価格）のことです。例えば、「1ドル＝150円」といった形で表示されます。このレートは、経済状況や金融政策、市場の需給など様々な要因で常に変動します。',
    relatedTerms: ['FX', '円高', '円安', 'クロスレート', 'インターバンク市場', '実効為替レート']
  },
  {
    id: 48,
    term: '円高',
    category: 'FX・為替',
    description: '外国の通貨に対して、日本の「円」の価値が高くなることです。例えば、これまで「1ドル＝150円」だったものが「1ドル＝140円」になると、より少ない円で1ドルと交換できるようになるため、円高といいます。',
    relatedTerms: ['円安', '為替レート', '為替変動リスク', '輸出企業', '輸入企業']
  },
  {
    id: 49,
    term: '円安',
    category: 'FX・為替',
    description: '外国の通貨に対して、日本の「円」の価値が低くなることです。例えば、これまで「1ドル＝150円」だったものが「1ドル＝160円」になると、より多くの円を出さないと1ドルと交換できなくなるため、円安といいます。',
    relatedTerms: ['円高', '為替レート', '為替変動リスク', '輸出企業', '輸入企業']
  },
  {
    id: 50,
    term: 'スワップポイント',
    category: 'FX・為替',
    description: 'FX取引において、2国間の通貨の金利差によって発生する調整額のことです。高金利通貨を買い、低金利通貨を売るポジションを保有していると、その金利差分をほぼ毎日受け取ることができます（逆の場合は支払いが発生）。金利情勢により変動します。',
    relatedTerms: ['FX', '金利差', '通貨ペア', 'ポジション', 'ロールオーバー', 'インカムゲイン']
  },
  {
    id: 51,
    term: 'レバレッジ',
    category: 'FX・為替',
    description: '「てこの原理」を意味し、FX取引などで、預けた証拠金の何倍もの金額の取引ができる仕組みのことです。例えばレバレッジ25倍なら、4万円の証拠金で100万円分の取引が可能です。少ない資金で大きな利益を狙える可能性がある一方、損失も同様に大きくなるリスクがあります。',
    relatedTerms: ['証拠金', 'FX', 'ハイリスク・ハイリターン', 'ロスカット', '追証', '必要証拠金']
  },
  {
    id: 52,
    term: '証拠金',
    category: 'FX・為替',
    description: 'FX取引などを行う際に、取引業者に担保として預け入れる資金のことです。「保証金」とも呼ばれます。取引に必要な最低限の証拠金（必要証拠金）があり、これを下回ると追加の証拠金（追証）が必要になったり、強制的に決済（ロスカット）されたりすることがあります。',
    relatedTerms: ['レバレッジ', 'FX', '必要証拠金', '追証', 'ロスカット', '証拠金維持率']
  },
  {
    id: 53,
    term: 'ロスカット',
    category: 'FX・為替',
    description: 'FX取引などで、保有しているポジションの損失が一定水準以上に拡大した場合に、さらなる損失の拡大を防ぐために、取引業者が強制的にそのポジションを決済する仕組みのことです。投資家保護の観点から設けられていますが、必ずしも預けた証拠金以上の損失が発生しないことを保証するものではありません。',
    relatedTerms: ['証拠金', 'レバレッジ', '追証', '強制決済', '証拠金維持率']
  },
  {
    id: 54,
    term: 'スプレッド',
    category: 'FX・為替',
    description: 'FX取引において、通貨を売るときの価格（BID/売値）と買うときの価格（ASK/買値）の差のことです。この差が実質的な取引コストの一つとなります。スプレッドは通貨ペアや市場の状況、取引業者によって異なります。一般的に狭い（小さい）方が投資家にとって有利です。',
    relatedTerms: ['FX', 'BID (売値)', 'ASK (買値)', '取引コスト', '通貨ペア', '提示レート']
  },
  {
    id: 55,
    term: 'ポジション',
    category: 'FX・為替',
    description: 'FX取引や株式取引などで、売買の約定後に決済されずに保有している未決済の建玉（たてぎょく）のことです。買いから入った場合は「買いポジション（ロングポジション）」、売りから入った場合は「売りポジション（ショートポジション）」といいます。',
    relatedTerms: ['FX', '建玉', 'ロングポジション', 'ショートポジション', '決済', '含み益', '含み損']
  },

  // --- テクニカル分析 ---
  {
    id: 56,
    term: 'テクニカル分析',
    category: 'テクニカル分析',
    description: '過去の株価や為替レートの価格変動、出来高などの市場データをグラフ（チャート）にして分析し、将来の値動きのパターンやトレンドを予測しようとする手法です。「市場の動きは全ての情報を織り込んでいる」「価格はトレンドを形成する」「歴史は繰り返す」といった考え方が基本にあります。',
    relatedTerms: ['ファンダメンタルズ分析', 'チャート', 'ローソク足', '移動平均線', 'トレンド', 'パターン分析', '出来高']
  },
  {
    id: 57,
    term: 'ローソク足',
    category: 'テクニカル分析',
    description: '一定期間（日中足、日足、週足、月足など）の始値、高値、安値、終値（四本値）を、ローソクのような形に図示したものです。株価や為替レートの動きや強弱、方向性を視覚的に把握しやすく、テクニカル分析の最も基本的なチャートの一つです。日本の江戸時代の米相場で考案されたと言われています。',
    relatedTerms: ['四本値', '陽線', '陰線', '同時線', 'ヒゲ (影)', '実体', 'チャートパターン', '酒田五法']
  },
  {
    id: 58,
    term: '移動平均線',
    category: 'テクニカル分析',
    description: '一定期間の終値の平均値を計算し、それを線で結んでグラフ化したテクニカル指標です。相場のトレンドの方向性や強弱、転換点を探るのに用いられます。また、支持線や抵抗線としての役割も果たします。短期線、中期線、長期線など、期間の異なる複数の線を組み合わせて分析することが一般的です。',
    relatedTerms: ['ゴールデンクロス', 'デッドクロス', 'トレンド分析', 'グランビルの法則', '単純移動平均', '指数平滑移動平均', '加重移動平均']
  },
  {
    id: 59,
    term: 'ゴールデンクロス',
    category: 'テクニカル分析',
    description: '株価や為替レートのチャートにおいて、期間の短い移動平均線が、期間の長い移動平均線を下から上に突き抜ける現象のことです。一般的に、相場が上昇トレンドに転換する買いのサインとされています。ただし、必ずしも上昇するとは限らず、「ダマシ」となる場合もあります。',
    relatedTerms: ['デッドクロス', '移動平均線', '買いサイン', '上昇トレンド', 'ダマシ']
  },
  {
    id: 60,
    term: 'デッドクロス',
    category: 'テクニカル分析',
    description: '株価や為替レートのチャートにおいて、期間の短い移動平均線が、期間の長い移動平均線を上から下に突き抜ける現象のことです。一般的に、相場が下降トレンドに転換する売りのサインとされています。ただし、ゴールデンクロス同様、「ダマシ」となる場合もあります。',
    relatedTerms: ['ゴールデンクロス', '移動平均線', '売りサイン', '下降トレンド', 'ダマシ']
  },
  {
    id: 61,
    term: 'MACD',
    category: 'テクニカル分析',
    description: '「マックディー」と読み、「移動平均収束拡散手法」と訳されます。期間の異なる2つの指数平滑移動平均線（EMA）の差（MACDライン）と、そのMACDラインの移動平均線（シグナルライン）を用いて、相場のトレンドの方向性や転換点、売買のタイミングを判断するテクニカル指標です。オシレーター系指標としてもトレンド系指標としても利用されます。',
    relatedTerms: ['移動平均線', 'EMA', 'シグナルライン', 'ヒストグラム', 'ゴールデンクロス', 'デッドクロス', 'ダイバージェンス']
  },
  {
    id: 62,
    term: 'RSI',
    category: 'テクニカル分析',
    description: '「相対力指数」と訳され、相場の「買われすぎ」や「売られすぎ」を判断するために用いられるオシレーター系のテクニカル指標です。一定期間の価格変動幅の中で、上昇分の割合がどれくらいかを0％から100％の数値で示します。一般的に70％以上で買われすぎ、30％以下で売られすぎと判断されます。',
    relatedTerms: ['オシレーター系指標', '買われすぎ', '売られすぎ', '逆張り', 'ダイバージェンス', 'ストキャスティクス']
  },
  {
    id: 63,
    term: 'ボリンジャーバンド',
    category: 'テクニカル分析',
    description: '移動平均線とその上下に統計学的な標準偏差（σ：シグマ）に基づいて描画される複数の線（バンド）から構成されるテクニカル指標です。価格の大部分がこのバンド内に収まるとされ、相場の勢いや反転の目安、ボラティリティ（価格変動の度合い）を視覚的に捉えるのに役立ちます。',
    relatedTerms: ['移動平均線', '標準偏差 (σ)', 'バンドウォーク', 'スクイーズ', 'エクスパンション', 'ボラティリティ']
  },
  {
    id: 64,
    term: '一目均衡表',
    category: 'テクニカル分析',
    description: '日本の株式評論家、細田悟一氏（ペンネーム：一目山人）が開発したテクニカル指標です。転換線、基準線、先行スパン1、先行スパン2、遅行スパンという5本の線と、先行スパン1と2で囲まれた「雲（抵抗帯）」を用いて、相場のトレンド、サポート/レジスタンス、転換点などを総合的に判断します。',
    relatedTerms: ['転換線', '基準線', '先行スパン', '遅行スパン', '雲 (抵抗帯)', '三役好転', '三役逆転']
  },
  {
    id: 65,
    term: 'トレンドライン',
    category: 'テクニカル分析',
    description: '株価や為替レートのチャート上で、価格の方向性（トレンド）を示すために引かれる直線のことです。上昇トレンドでは安値同士を、下降トレンドでは高値同士を結んで描画します。トレンドの継続や転換、サポートラインやレジスタンスラインとして機能します。',
    relatedTerms: ['上昇トレンド', '下降トレンド', 'サポートライン', 'レジスタンスライン', 'チャネルライン', 'ダウ理論']
  },
  {
    id: 66,
    term: 'サポートライン',
    category: 'テクニカル分析',
    description: '「支持線」とも呼ばれ、株価や為替レートが下落した際に、それ以上の下落を食い止める可能性が高いとされる価格水準を示す水平線または右肩上がりの線のことです。過去に何度も価格が反発した安値を結んで描かれます。この水準では買い圧力が強まると考えられます。',
    relatedTerms: ['レジスタンスライン', 'トレンドライン', '下値支持線', '反発', '買い圧力']
  },
  {
    id: 67,
    term: 'レジスタンスライン',
    category: 'テクニカル分析',
    description: '「抵抗線」とも呼ばれ、株価や為替レートが上昇した際に、それ以上の上昇を抑える可能性が高いとされる価格水準を示す水平線または右肩下がりの線のことです。過去に何度も価格が反落した高値を結んで描かれます。この水準では売り圧力が強まると考えられます。',
    relatedTerms: ['サポートライン', 'トレンドライン', '上値抵抗線', '反落', '売り圧力']
  },
  {
    id: 68,
    term: '出来高',
    category: 'テクニカル分析',
    description: '一定期間内に成立した株式などの売買数量（株数や枚数）のことです。市場の活況度や関心の高まりを示し、価格トレンドの信頼性を判断する上で重要な指標となります。一般的に、価格が上昇する際に出来高が増加すると強い上昇トレンド、価格が下落する際に出来高が増加すると強い下降トレンドとされます。',
    relatedTerms: ['株価', '価格変動', '市場参加者', '売買代金', '出来高急増', 'トレンド分析']
  },
  {
    id: 69,
    term: 'オシレーター系指標',
    category: 'テクニカル分析',
    description: '相場の「買われすぎ」や「売られすぎ」といった過熱感や、相場の勢いの強弱を示すテクニカル指標の総称です。「振り子」のように一定の範囲で数値が変動することから名付けられました。主にレンジ相場（ボックス相場）での逆張りに有効とされます。代表例にRSIやストキャスティクスがあります。',
    relatedTerms: ['トレンド系指標', 'RSI', 'ストキャスティクス', '買われすぎ', '売られすぎ', '逆張り', 'ダイバージェンス', 'レンジ相場']
  },
  {
    id: 70,
    term: 'トレンド系指標',
    category: 'テクニカル分析',
    description: '相場の方向性（トレンド）の有無や強弱を判断するために用いられるテクニカル指標の総称です。主にトレンド相場での順張りに有効とされます。代表例に移動平均線やMACD、一目均衡表などがあります。',
    relatedTerms: ['オシレーター系指標', '移動平均線', 'MACD', '一目均衡表', 'トレンド相場', '順張り', 'ダウ理論']
  },

  // --- ファンダメンタルズ分析 --- //
  {
    id: 71,
    term: 'ファンダメンタルズ分析',
    category: 'ファンダメンタルズ分析',
    description: '企業の財務状況（財務諸表）、業績、経営戦略、成長性や、マクロ経済（金利、物価、景気動向など）といった基礎的要因（ファンダメンタルズ）を分析し、株価の本来あるべき価値（理論株価）を評価し、現在の株価が割安か割高かを判断する手法です。長期的な投資判断に適しているとされます。',
    relatedTerms: ['テクニカル分析', '財務諸表', '経済指標', '企業価値評価', 'PER', 'PBR', 'ROE', '成長株', '割安株']
  },
  {
    id: 72,
    term: 'PER',
    category: 'ファンダメンタルズ分析',
    description: '「株価収益率」と訳されます。現在の株価が、その企業の1株当たりの当期純利益（EPS）の何倍であるかを示す指標です。一般的に、この数値が低いほど株価が利益に対して割安であると判断されます。同業他社や市場平均、その企業の過去の数値と比較して評価します。',
    relatedTerms: ['EPS', 'PBR', 'ROE', '株価', '当期純利益', '割安株', '益利回り']
  },
  {
    id: 73,
    term: 'PBR',
    category: 'ファンダメンタルズ分析',
    description: '「株価純資産倍率」と訳されます。現在の株価が、その企業の1株当たりの純資産（BPS）の何倍であるかを示す指標です。一般的に、この数値が低いほど株価が純資産に対して割安であると判断されます。1倍が解散価値の目安とされることもあります。',
    relatedTerms: ['BPS', 'PER', 'ROE', '株価', '純資産', '解散価値', '割安株']
  },
  {
    id: 74,
    term: 'ROE',
    category: 'ファンダメンタルズ分析',
    description: '「自己資本利益率」と訳されます。企業が株主から集めた自己資本（純資産）を使って、どれだけ効率的に利益を上げているかを示す財務指標です。ROEが高いほど、資本効率が良く、収益性が高いと評価されます。計算式は「当期純利益 ÷ 自己資本 × 100 (%)」。',
    relatedTerms: ['自己資本', '当期純利益', 'ROA', 'EPS', 'PBR', '資本効率', '株主価値']
  },
  {
    id: 75,
    term: 'EPS',
    category: 'ファンダメンタルズ分析',
    description: '「1株当たり当期純利益」または「1株当たり利益」と訳されます。企業が1年間で上げた当期純利益を発行済株式数で割ったもので、1株に対してどれだけの利益が生み出されたかを示します。企業の収益力や成長性を測る指標の一つです。PERの計算にも用いられます。',
    relatedTerms: ['当期純利益', '発行済株式数', 'PER', 'ROE', '収益性', '成長性']
  },
  {
    id: 76,
    term: 'BPS',
    category: 'ファンダメンタルズ分析',
    description: '「1株当たり純資産」と訳されます。企業の純資産（総資産から負債を差し引いたもの）を発行済株式数で割ったもので、1株に対してどれだけの純資産があるかを示します。企業の安定性や解散価値を測る目安となります。PBRの計算にも用いられます。',
    relatedTerms: ['純資産', '発行済株式数', 'PBR', 'ROE', '安定性', '解散価値']
  },
  {
    id: 77,
    term: '配当利回り',
    category: 'ファンダメンタルズ分析',
    description: '現在の株価に対して、1年間でどれだけの配当金を受け取れるかを示す割合（％）です。計算式は「1株当たり年間配当金 ÷ 株価 × 100」。インカムゲインを重視する投資家にとって重要な指標の一つです。',
    relatedTerms: ['配当金', '株価', 'インカムゲイン', '高配当株', '配当性向']
  },
  {
    id: 78,
    term: '自己資本比率',
    category: 'ファンダメンタルズ分析',
    description: '企業の総資本（負債と純資産の合計）のうち、返済義務のない自己資本（純資産）が占める割合を示す財務指標です。この比率が高いほど、借入金への依存度が低く、財務の健全性や安定性が高いと評価されます。計算式は「自己資本 ÷ 総資本 × 100 (%)」。',
    relatedTerms: ['自己資本', '総資本', '負債', '財務健全性', '財務レバレッジ', 'ROE']
  },
  {
    id: 79,
    term: 'キャッシュフロー',
    category: 'ファンダメンタルズ分析',
    description: '企業活動における現金の流れ（収入と支出）のことです。「営業活動によるキャッシュフロー」「投資活動によるキャッシュフロー」「財務活動によるキャッシュフロー」の3つに分類され、キャッシュフロー計算書で示されます。企業の支払い能力や資金繰りの状況を把握する上で重要です。',
    relatedTerms: ['キャッシュフロー計算書', '営業CF', '投資CF', '財務CF', 'フリーキャッシュフロー', '資金繰り']
  },
  {
    id: 80,
    term: '損益計算書',
    category: 'ファンダメンタルズ分析',
    description: '企業の一会計期間（通常1年間）における経営成績、つまりどれだけ儲けたか（または損したか）を示す財務諸表の一つです。「P/L（Profit and Loss Statement）」とも呼ばれます。売上高から始まり、売上原価、販売費及び一般管理費などを差し引いて各段階の利益（営業利益、経常利益、当期純利益など）を計算表示します。',
    relatedTerms: ['貸借対照表 (B/S)', 'キャッシュフロー計算書 (C/S)', '財務三表', '売上高', '営業利益', '経常利益', '当期純利益', '決算']
  },
  {
    id: 81,
    term: '貸借対照表',
    category: 'ファンダメンタルズ分析',
    description: '企業の決算日時点における財政状態（どのような資産を保有し、それがどのような負債と純資産で調達されたか）を示す財務諸表の一つです。「B/S（Balance Sheet）」とも呼ばれます。左側に資産、右側に負債と純資産が記載され、左右の合計額は必ず一致します（貸借平均の原理）。',
    relatedTerms: ['損益計算書 (P/L)', 'キャッシュフロー計算書 (C/S)', '財務三表', '資産', '負債', '純資産 (自己資本)', '決算']
  },
  {
    id: 82,
    term: '決算短信',
    category: 'ファンダメンタルズ分析',
    description: '上場企業が事業年度（四半期ごと、または通期）の決算発表を行う際に、証券取引所のルールに基づいて開示する速報資料です。損益計算書や貸借対照表の主要項目、業績予想などが簡潔にまとめられています。投資家にとって重要な情報源の一つです。',
    relatedTerms: ['有価証券報告書', '決算発表', '業績予想', '財務諸表', '適時開示']
  },
  {
    id: 83,
    term: '有価証券報告書',
    category: 'ファンダメンタルズ分析',
    description: '上場企業などが各事業年度終了後3ヶ月以内に内閣総理大臣（金融庁）に提出することが義務付けられている開示資料です。企業の概況、事業の内容、財務諸表（連結・個別）とその注記、役員の状況など、詳細な情報が記載されており、「決算短信」よりも網羅的です。「有報（ゆうほう）」と略されます。',
    relatedTerms: ['決算短信', 'EDINET', '財務諸表', '開示資料', '金融商品取引法']
  },
  {
    id: 84,
    term: 'アナリストレポート',
    category: 'ファンダメンタルズ分析',
    description: '証券会社や調査機関などに所属するアナリストが、特定の企業や業界について調査・分析し、その結果や投資判断（レーティング）、目標株価などをまとめた報告書です。投資家が投資判断を行う際の参考情報の一つとなります。',
    relatedTerms: ['証券アナリスト', 'レーティング', '目標株価', 'セルサイドアナリスト', 'バイサイドアナリスト']
  },
  {
    id: 85,
    term: '成長株',
    category: 'ファンダメンタルズ分析',
    description: '企業の売上や利益が市場平均よりも高い成長率で伸びており、将来のさらなる成長が期待される株式のことです。一般的にPERやPBRは高めになる傾向がありますが、株価の大幅な上昇も期待されます。ハイテク関連企業などに多く見られます。',
    relatedTerms: ['割安株 (バリュー株)', 'グロース投資', 'PER', 'EPS成長率', 'イノベーション']
  },
  {
    id: 86,
    term: '割安株',
    category: 'ファンダメンタルズ分析',
    description: '企業の実際の価値（本源的価値）に比べて、現在の株価が低い（割安な）状態にあると判断される株式のことです。「バリュー株」とも呼ばれます。PERやPBRなどの指標が市場平均や同業他社と比較して低いことが一つの目安となります。株価が適正水準に戻ることを期待して投資されます。',
    relatedTerms: ['成長株 (グロース株)', 'バリュー投資', 'PER', 'PBR', '安全域']
  },

  // --- 市場・経済指標 (Market & Economic Indicators) ---
  {
    id: 87,
    term: '日経平均株価',
    category: '市場・経済指標',
    description: '日本経済新聞社が算出・公表している、東京証券取引所プライム市場に上場する代表的な225銘柄の株価を基にした株価指数です。日本の株式市場全体の動向を示す代表的な指標の一つとされ、ニュースなどで頻繁に引用されます。構成銘柄は定期的に見直されます。',
    relatedTerms: ['TOPIX', '株価指数', 'ダウ式平均', '東京証券取引所', '構成銘柄', '日経平均先物']
  },
  {
    id: 88,
    term: 'TOPIX',
    category: '市場・経済指標',
    description: '「東証株価指数」と訳され、東京証券取引所に上場する全銘柄（プライム、スタンダード、グロース市場の区別なく、2022年4月以降は段階的に移行）の時価総額を基準日（1968年1月4日＝100ポイント）と比較して指数化したものです。市場全体の規模や動向をより広範に反映するとされています。',
    relatedTerms: ['日経平均株価', '株価指数', '時価総額加重平均', '東京証券取引所', '浮動株基準']
  },
  {
    id: 89,
    term: 'NYダウ',
    category: '市場・経済指標',
    description: '「ダウ工業株30種平均」とも呼ばれ、S&P ダウ・ジョーンズ・インデックス社が算出する、米国の代表的な30銘柄の株価を基にした株価平均型の指数です。米国の株式市場だけでなく、世界の株式市場にも大きな影響を与える重要な指標の一つです。',
    relatedTerms: ['S&P500', 'ナスダック総合指数', '米国株式市場', '株価平均', 'ブルーチップ']
  },
  {
    id: 90,
    term: 'S&P500',
    category: '市場・経済指標',
    description: 'S&P ダウ・ジョーンズ・インデックス社が算出する、ニューヨーク証券取引所やNASDAQなどに上場している代表的な500銘柄の株価を基にした時価総額加重平均型の株価指数です。米国株式市場の動向をより広範に反映する指標として、機関投資家の運用ベンチマークとしても広く利用されています。',
    relatedTerms: ['NYダウ', 'ナスダック総合指数', '米国株式市場', '時価総額加重平均', 'ベンチマーク']
  },
  {
    id: 91,
    term: 'ナスダック総合指数',
    category: '市場・経済指標',
    description: '米国のNASDAQ（ナスダック）証券取引所に上場する全銘柄（約3,000銘柄）の株価を時価総額加重平均で算出した株価指数です。ハイテク企業やIT関連企業、新興企業が多く含まれているのが特徴で、これらの業界の動向を強く反映します。',
    relatedTerms: ['NYダウ', 'S&P500', 'NASDAQ', 'ハイテク株', '新興企業', 'ITバブル']
  },
  {
    id: 92,
    term: 'GDP',
    category: '市場・経済指標',
    description: '「国内総生産」と訳されます。一定期間内（通常1年間または四半期）に、一国の国内で新たに生産されたモノやサービスの付加価値の合計額です。その国の経済活動の規模や成長率を示す最も代表的な経済指標であり、景気判断の重要な材料となります。',
    relatedTerms: ['経済成長率', 'GNP (国民総生産)', '名目GDP', '実質GDP', '三面等価の原則', '内需', '外需']
  },
  {
    id: 93,
    term: '消費者物価指数',
    category: '市場・経済指標',
    description: '全国の消費者が購入する商品やサービスの価格変動を総合的に測定した経済指標です。物価の変動（インフレーションやデフレーション）の状況を把握するために用いられ、金融政策の判断材料ともなります。「CPI」と略されます。天候に左右されやすい生鮮食品を除いた「コアCPI」も重視されます。',
    relatedTerms: ['インフレーション', 'デフレーション', '物価', 'コアCPI', '生産者物価指数', '金融政策']
  },
  {
    id: 94,
    term: '政策金利',
    category: '市場・経済指標',
    description: '各国の中央銀行（日本なら日本銀行）が、金融政策の手段として設定する短期金利の誘導目標のことです。景気の安定や物価の安定を目的として、景気過熱時には引き上げ（利上げ）、景気後退時には引き下げ（利下げ）が行われます。市場金利全体に影響を与えます。',
    relatedTerms: ['日本銀行 (日銀)', 'FRB (連邦準備制度理事会)', 'ECB (欧州中央銀行)', '金融政策', '利上げ', '利下げ', '公開市場操作']
  },
  {
    id: 95,
    term: '失業率',
    category: '市場・経済指標',
    description: '労働力人口（15歳以上で働く意思と能力を持つ人）のうち、失業者（職がなく求職活動をしている人）が占める割合を示す経済指標です。景気の状況を反映し、景気が悪化すると上昇し、改善すると低下する傾向があります。完全雇用時の失業率（構造的失業・摩擦的失業）も考慮されます。',
    relatedTerms: ['有効求人倍率', '労働力人口', '完全雇用', '景気動向', '雇用統計']
  },
  {
    id: 96,
    term: '景気動向指数',
    category: '市場・経済指標',
    description: '生産、雇用、消費など様々な経済活動に関する複数の指標を統合し、景気の現状把握や将来予測を行うために作成される経済指標です。内閣府が毎月発表しています。景気の方向性を示す「DI（Diffusion Index）」と、景気の変動の大きさ（量感）を示す「CI（Composite Index）」があります。',
    relatedTerms: ['DI', 'CI', '先行指数', '一致指数', '遅行指数', '景気循環', '景気ウォッチャー調査']
  },
  {
    id: 97,
    term: 'インフレーション',
    category: '市場・経済指標',
    description: '「インフレ」と略され、モノやサービスの価格（物価）が全般的に持続して上昇し、相対的にお金の価値が下がることです。需要が供給を上回る（ディマンドプル・インフレ）や、原材料費の高騰（コストプッシュ・インフレ）などが原因となります。適度なインフレは経済成長に繋がるとされますが、急激なものは経済に悪影響を与えます。',
    relatedTerms: ['デフレーション', '消費者物価指数', 'スタグフレーション', 'ハイパーインフレ', '金利', '通貨価値', 'デフレ期待']
  },
  {
    id: 98,
    term: 'デフレーション',
    category: '市場・経済指標',
    description: '「デフレ」と略され、モノやサービスの価格（物価）が全般的に持続して下落し、相対的にお金の価値が上がることです。需要の低迷や供給過剰などが原因となります。物価下落が企業収益の悪化や賃金減少を招き、それが更なる需要低迷に繋がる「デフレスパイラル」に陥る懸念があります。',
    relatedTerms: ['インフレーション', '消費者物価指数', 'デフレスパイラル', '名目金利', '実質金利', '資産デフレ']
  },
  {
    id: 99,
    term: '金融緩和',
    category: '市場・経済指標',
    description: '中央銀行が、景気刺激やデフレ脱却を目的として、市中に出回るお金の量を増やしたり、金利を引き下げたりする金融政策のことです。具体的には、政策金利の引き下げ、国債などの資産買い入れ（量的緩和）、マイナス金利政策などがあります。',
    relatedTerms: ['金融引き締め', '中央銀行', '日本銀行', 'FRB', '政策金利', '量的緩和', 'マイナス金利']
  },
  {
    id: 100,
    term: '金融引き締め',
    category: '市場・経済指標',
    description: '中央銀行が、景気の過熱やインフレの進行を抑制するために、市中に出回るお金の量を減らしたり、金利を引き上げたりする金融政策のことです。具体的には、政策金利の引き上げ、資産買い入れの縮小・停止などがあります。',
    relatedTerms: ['金融緩和', '中央銀行', '日本銀行', 'FRB', '政策金利', '利上げ', 'インフレ抑制']
  },

  // --- 制度・税金 (System & Tax) --- (ID: 101 onwards are new)
  {
    id: 101,
    term: 'NISA',
    category: '制度・税金',
    description: '「少額投資非課税制度」の愛称です。個人投資家が株式や投資信託などで得た配当金や譲渡益（売却益）が、一定の年間投資枠内であれば非課税になる税制優遇制度です。2024年から新しいNISA制度が開始され、「つみたて投資枠」と「成長投資枠」の2つの枠が設けられました。',
    relatedTerms: ['つみたてNISA (旧)', '一般NISA (旧)', '成長投資枠', 'つみたて投資枠', 'iDeCo', '非課税投資枠', 'ロールオーバー']
  },
  {
    id: 102,
    term: 'つみたてNISA',
    category: '制度・税金',
    description: '2023年までのNISA制度の一つで、特に少額からの長期・積立・分散投資を支援するための非課税制度でした。年間40万円までの投資額で購入した一定の投資信託などから得られる分配金や譲渡益が最長20年間非課税となりました。2024年からの新しいNISAでは「つみたて投資枠」に機能が引き継がれています。',
    relatedTerms: ['NISA', '成長投資枠', 'つみたて投資枠', '長期投資', '積立投資', 'ドルコスト平均法']
  },
  {
    id: 103,
    term: 'iDeCo',
    category: '制度・税金',
    description: '「個人型確定拠出年金」の愛称です。自分で掛金を拠出し、自分で運用商品（投資信託、預金など）を選んで運用し、将来の年金資産を形成する私的年金制度です。掛金が全額所得控除、運用益が非課税、受取時にも税制優遇があるなど、税制メリットが大きいです。原則として60歳まで引き出すことはできません。',
    relatedTerms: ['NISA', '確定拠出年金', '企業型DC', '年金制度', '所得控除', '税制優遇', '老後資金', 'マッチング拠出']
  },
  {
    id: 104,
    term: '特定口座',
    category: '制度・税金',
    description: '上場株式や投資信託などの売買で得た利益（譲渡益）や配当金などに対する税金の計算や納税手続きを、証券会社が投資家に代わって行うための口座制度です。「源泉徴収あり」と「源泉徴収なし」の2種類があり、「源泉徴収あり」を選ぶと原則として確定申告が不要になります。',
    relatedTerms: ['一般口座', '源泉徴収', '確定申告', 'NISA口座', '譲渡所得', '申告分離課税']
  },
  {
    id: 105,
    term: '一般口座',
    category: '制度・税金',
    description: '株式や投資信託などを取引する際に、特定口座やNISA口座を利用しない場合に開設される口座です。一般口座で取引した場合、年間の譲渡損益や配当金などを投資家自身で計算し、原則として確定申告を行う必要があります。',
    relatedTerms: ['特定口座', 'NISA口座', '確定申告', '年間取引報告書', '譲渡損益']
  },
  {
    id: 106,
    term: '源泉徴収',
    category: '制度・税金',
    description: '給与や利子、配当、報酬などを支払う者が、それらを支払う際に所得税などをあらかじめ天引きし、受け取る人に代わって国に納付する制度です。特定口座の「源泉徴収あり」を選択すると、株式などの譲渡益や配当金等から税金が源泉徴収されます。',
    relatedTerms: ['特定口座', '確定申告', '所得税', '配当所得', '譲渡所得']
  },
  {
    id: 107,
    term: '確定申告',
    category: '制度・税金',
    description: '1年間の所得とそれに対する所得税額を計算し、税務署に申告・納税する手続きのことです。株式投資においては、一般口座での取引や、特定口座（源泉徴収なし）での取引、複数の証券会社で損益通算する場合、損失を翌年以降に繰り越す場合などに必要となります。',
    relatedTerms: ['特定口座', '一般口座', '源泉徴収', '損益通算', '繰越控除', '所得税', '医療費控除']
  },
  {
    id: 108,
    term: '損益通算',
    category: '制度・税金',
    description: '一定期間内の複数の所得や損失を合算し、課税対象となる所得を計算することです。株式投資においては、複数の証券口座での利益と損失を合算したり、上場株式等の譲渡損失を申告分離課税の配当所得等と相殺したりすることができます。確定申告が必要です。',
    relatedTerms: ['確定申告', '繰越控除', '譲渡損失', '配当所得', '申告分離課税']
  },
  {
    id: 109,
    term: '繰越控除',
    category: '制度・税金',
    description: '株式投資などで発生した年間の譲渡損失のうち、その年に損益通算してもなお控除しきれなかった損失額を、翌年以降3年間にわたって繰り越し、各年の利益から控除できる制度です。利用するには毎年確定申告が必要です。',
    relatedTerms: ['確定申告', '損益通算', '譲渡損失', '上場株式等']
  },
  {
    id: 110,
    term: '金融所得課税',
    category: '制度・税金',
    description: '預貯金の利子、株式の配当金や売買益、投資信託の分配金や売買益などの金融商品から得られる所得に対する課税の総称です。多くは他の所得と分離して税額を計算する「申告分離課税」が適用されます。税率は所得の種類や時期によって異なります。',
    relatedTerms: ['申告分離課税', '源泉分離課税', '総合課税', '譲渡所得', '配当所得', '利子所得']
  },

  // --- リスク管理 ---
  {
    id: 111,
    term: '分散投資',
    category: 'リスク管理',
    description: '投資資金を一つの金融商品や銘柄に集中せず、複数の異なる値動きをする可能性のある資産（株式、債券、不動産など）、地域（国内、海外）、時間（時期をずらす）などに分けて投資することで、全体のリスクを低減させる運用手法です。「卵は一つのカゴに盛るな」という格言で知られています。',
    relatedTerms: ['ポートフォリオ', 'アセットアロケーション', 'リスクヘッジ', '相関関係', '国際分散投資', '時間分散']
  },
  {
    id: 112,
    term: 'ポートフォリオ',
    category: 'リスク管理',
    description: '投資家が保有する株式、債券、投資信託、預貯金、不動産などの金融商品の具体的な組み合わせや一覧のことです。適切なポートフォリオを組むことで、リスクを管理しつつ、目標とするリターンを目指します。',
    relatedTerms: ['分散投資', 'アセットアロケーション', 'リスク許容度', 'リバランス', '現代ポートフォリオ理論']
  },
  {
    id: 113,
    term: 'アセットアロケーション',
    category: 'リスク管理',
    description: '投資資金を、株式、債券、不動産、コモディティ、現金など、異なる種類の資産（アセットクラス）にどのような割合で配分するかを決定することです。ポートフォリオ運用の基本戦略であり、投資成果に大きな影響を与える要素とされています。個人のリスク許容度や投資目標に応じて決定します。',
    relatedTerms: ['ポートフォリオ', '分散投資', 'リスク許容度', 'アセットクラス', 'リバランス']
  },
  {
    id: 114,
    term: 'リスク許容度',
    category: 'リスク管理',
    description: '投資家が、資産運用を行う上でどの程度の価格変動リスクや損失の可能性を受け入れられるか、その度合いのことです。年齢、収入、資産状況、投資経験、性格などによって個人差があります。適切なポートフォリオを組む上で重要な要素となります。',
    relatedTerms: ['ポートフォリオ', 'アセットアロケーション', 'リスク', 'ハイリスク・ハイリターン', 'ローリスク・ローリターン']
  },
  {
    id: 115,
    term: 'ボラティリティ',
    category: 'リスク管理',
    description: '株式や為替などの金融商品の価格変動の度合い（大きさ）を示す言葉です。ボラティリティが高いとは価格変動が大きい（価格が不安定でリスクが高い）ことを意味し、低いとは価格変動が小さい（価格が安定的でリスクが低い）ことを意味します。一般的に標準偏差などで計測されます。',
    relatedTerms: ['標準偏差', 'リスク', '価格変動リスク', 'VIX指数 (恐怖指数)', 'オプション取引']
  },
  {
    id: 116,
    term: '損切り',
    category: 'リスク管理',
    description: '保有している金融商品の価格が下落し、損失が発生している場合に、さらなる損失の拡大を防ぐために、その商品を売却して損失を確定させることです。「ロスカット」とも言います。感情に左右されず、あらかじめ決めたルールに従って機械的に行うことが重要とされています。',
    relatedTerms: ['ロスカット', 'リスク管理', '利益確定', '逆指値注文', '投資ルール']
  },
  {
    id: 117,
    term: 'ヘッジ',
    category: 'リスク管理',
    description: '保有している資産の価格変動リスクを回避または軽減するために、反対のポジションを取ったり、異なる金融商品を利用したりする取引のことです。「リスクヘッジ」とも言います。例えば、保有株の値下がりリスクに対して、株価指数先物を売るなどの手法があります。',
    relatedTerms: ['リスクヘッジ', '分散投資', '先物取引', 'オプション取引', '空売り']
  },
  {
    id: 118,
    term: 'VaR',
    category: 'リスク管理',
    description: '「バリュー・アット・リスク」と読み、金融資産ポートフォリオが、ある一定期間（例：1日、10日）において、ある一定の確率（例：99％、95％）の範囲内で被る可能性のある最大損失額を統計的に推計したものです。金融機関のリスク管理などで利用されます。',
    relatedTerms: ['リスク管理', 'ポートフォリオ', '標準偏差', '確率分布', 'ストレステスト']
  },
  {
    id: 119,
    term: 'リスクリワードレシオ',
    category: 'リスク管理',
    description: '1回の取引における、予想される平均利益（リワード）と平均損失（リスク）の比率のことです。例えば、1回の取引で平均10万円の利益が見込め、平均5万円の損失が予想される場合、リスクリワードレシオは2（10÷5）となります。この数値が高いほど、効率的な取引とされます。',
    relatedTerms: ['損切り', '利益確定', '勝率', '期待値', 'トレード戦略']
  },
  {
    id: 120,
    term: '標準偏差',
    category: 'リスク管理',
    description: 'データのばらつきの度合いを示す統計的な指標です。投資の世界では、リターンのばらつき（価格変動の大きさ）、つまりリスクの大きさを測るためによく用いられます。標準偏差が大きいほど、リターンの振れ幅が大きく、リスクが高いと評価されます。ボラティリティの指標としても使われます。',
    relatedTerms: ['ボラティリティ', 'リスク', 'リターン', '正規分布', 'シャープレシオ']
  },

  // --- 投資戦略・手法 (Investment Strategy & Method) ---
  {
    id: 121,
    term: 'ドルコスト平均法',
    category: '投資戦略・手法',
    description: '定期的に一定の金額で、同じ金融商品（株式や投資信託など）を継続して購入していく投資手法です。価格が高いときには購入量が少なく、価格が安いときには購入量が多くなるため、平均購入単価を平準化する効果が期待できます。長期的な積立投資に適しています。',
    relatedTerms: ['積立投資', '定期購入', '時間分散', '長期投資', '投資信託', 'NISA (つみたて投資枠)']
  },
  {
    id: 122,
    term: 'バリュー投資',
    category: '投資戦略・手法',
    description: '企業の財務諸表などを分析し、その企業の本質的な価値（ファンダメンタルバリュー）に比べて現在の株価が割安（アンダーバリュー）と判断される銘柄に投資する手法です。株価が適正な水準に戻る過程での値上がり益を狙います。ウォーレン・バフェット氏が代表的なバリュー投資家として知られています。',
    relatedTerms: ['割安株 (バリュー株)', 'ファンダメンタルズ分析', 'PER', 'PBR', '安全域', 'ベンジャミン・グレアム']
  },
  {
    id: 123,
    term: 'グロース投資',
    category: '投資戦略・手法',
    description: '企業の売上高や利益が高い成長率を示しており、将来もその成長が続くと期待される銘柄（成長株）に投資する手法です。現在の株価が割高に見えても、将来の大きな成長による株価上昇を期待します。ハイテク企業や新興企業などが対象となることが多いです。',
    relatedTerms: ['成長株 (グロース株)', 'ファンダメンタルズ分析', 'EPS成長率', 'イノベーション', '将来性']
  },
  {
    id: 124,
    term: 'インカムゲイン',
    category: '投資戦略・手法',
    description: '株式の配当金、投資信託の分配金、債券の利子、不動産の賃料収入など、資産を保有していることによって継続的に得られる収益のことです。キャピタルゲインと対比される概念です。',
    relatedTerms: ['キャピタルゲイン', '配当金', '分配金', '利子', '不動産賃料', '安定収入', '高配当株投資']
  },
  {
    id: 125,
    term: 'キャピタルゲイン',
    category: '投資戦略・手法',
    description: '保有している株式や不動産などの資産を、購入時よりも高い価格で売却することによって得られる売買差益のことです。「値上がり益」とも言います。インカムゲインと対比される概念です。売却価格が購入価格を下回った場合は「キャピタルロス」となります。',
    relatedTerms: ['インカムゲイン', '売買差益', '譲渡益', '値上がり益', 'キャピタルロス', '成長株投資']
  },
  {
    id: 126,
    term: '長期投資',
    category: '投資戦略・手法',
    description: '数年から数十年といった長い期間にわたって金融商品を保有し続け、複利効果や企業の成長によるリターンを期待する投資スタイルです。短期的な価格変動に一喜一憂せず、じっくりと資産を育てることを目指します。',
    relatedTerms: ['短期投資', '積立投資', 'ドルコスト平均法', '複利効果', '資産形成']
  },
  {
    id: 127,
    term: '短期投資',
    category: '投資戦略・手法',
    description: '数日から数週間、あるいは数ヶ月程度の短い期間で金融商品を売買し、小さな値動きから利益を積み重ねることを目指す投資スタイルです。市場の動向を頻繁にチェックし、迅速な判断が求められます。デイトレードやスイングトレードなどが含まれます。',
    relatedTerms: ['長期投資', 'デイトレード', 'スイングトレード', 'スキャルピング', '投機']
  },
  {
    id: 128,
    term: 'スイングトレード',
    category: '投資戦略・手法',
    description: '数日から数週間程度の期間で売買を完結させる短期的な取引スタイルのことです。日中の値動きに常に注目する必要があるデイトレードよりは時間的な余裕があり、ある程度のトレンド（スイング）に乗って利益を狙います。',
    relatedTerms: ['デイトレード', 'スキャルピング', '短期投資', 'テクニカル分析', 'トレンドフォロー']
  },
  {
    id: 129,
    term: 'デイトレード',
    category: '投資戦略・手法',
    description: '1日のうちに株式やFXなどの売買を完結させ、翌日にポジションを持ち越さない取引スタイルのことです。わずかな値動きを捉えて利益を積み重ねることを目指し、市場が開いている間は常に価格動向を注視する必要があります。',
    relatedTerms: ['スイングトレード', 'スキャルピング', '短期投資', '日計り取引', 'ポジション']
  },
  {
    id: 130,
    term: 'スキャルピング',
    category: '投資戦略・手法',
    description: '数秒から数分といった非常に短い時間で、ごくわずかな値動き（数ティック程度）を狙って1日に何度も売買を繰り返す超短期的な取引スタイルのことです。高い集中力と迅速な判断力、低コストな取引環境が求められます。',
    relatedTerms: ['デイトレード', 'スイングトレード', 'ティック', '約定力', 'スプレッド']
  },

  // --- デリバティブ ---
  {
    id: 131,
    term: 'デリバティブ',
    category: 'デリバティブ',
    description: '「金融派生商品」と訳されます。株式、債券、為替、金利、コモディティなどの伝統的な金融商品（原資産）から派生して生まれた金融取引の総称です。代表的なものに先物取引、オプション取引、スワップ取引などがあります。リスクヘッジや効率的な資金運用、ハイリスク・ハイリターンな投機などに利用されます。',
    relatedTerms: ['先物取引', 'オプション取引', 'スワップ取引', '原資産', 'リスクヘッジ', '投機', '金融工学']
  },
  {
    id: 132,
    term: '先物取引',
    category: 'デリバティブ',
    description: '将来の特定の期日（限月）にあらかじめ決められた価格で、特定の商品（原資産：株価指数、コモディティ、通貨など）を売買することを約束する取引です。主に価格変動リスクのヘッジや、価格変動を予想した投機目的で利用されます。取引所を通じて標準化された契約で行われます。',
    relatedTerms: ['オプション取引', '限月', 'SQ (特別清算指数)', '差金決済', '証拠金取引', '日経225先物', '原油先物']
  },
  {
    id: 133,
    term: 'オプション取引',
    category: 'デリバティブ',
    description: '将来の特定の期日（権利行使期日）までに、あらかじめ決められた価格（権利行使価格）で、特定の商品（原資産）を買う権利（コールオプション）または売る権利（プットオプション）を売買する取引です。権利の買い手は権利料（プレミアム）を支払い、権利を行使するか放棄するかを選べます。',
    relatedTerms: ['コールオプション', 'プットオプション', '権利行使価格', 'プレミアム (権利料)', '権利行使期日', '原資産', 'ボラティリティ']
  },
  {
    id: 134,
    term: 'コールオプション',
    category: 'デリバティブ',
    description: 'オプション取引の一種で、将来の特定の期日までに、あらかじめ決められた価格（権利行使価格）で、特定の商品（原資産）を買うことができる権利のことです。原資産の価格が権利行使価格を上回ると予想する場合に購入されます。',
    relatedTerms: ['プットオプション', 'オプション取引', '権利行使価格', 'プレミアム', '原資産価格上昇期待']
  },
  {
    id: 135,
    term: 'プットオプション',
    category: 'デリバティブ',
    description: 'オプション取引の一種で、将来の特定の期日までに、あらかじめ決められた価格（権利行使価格）で、特定の商品（原資産）を売ることができる権利のことです。原資産の価格が権利行使価格を下回ると予想する場合に購入されます。',
    relatedTerms: ['コールオプション', 'オプション取引', '権利行使価格', 'プレミアム', '原資産価格下落期待']
  },
  {
    id: 136,
    term: '日経225先物',
    category: 'デリバティブ',
    description: '日経平均株価（Nikkei 225）を原資産とする株価指数先物取引のことです。大阪取引所（OSE）などで取引されています。日本の株式市場全体の動向を予測した取引や、保有株式ポートフォリオのリスクヘッジなどに利用されます。',
    relatedTerms: ['先物取引', '日経平均株価', '株価指数先物', 'SQ', '大阪取引所', 'CME日経225先物']
  },
  {
    id: 137,
    term: 'CFD',
    category: 'デリバティブ',
    description: '「差金決済取引」と訳されます。実際に株式や株価指数、コモディティなどの原資産を保有することなく、売買価格の差額だけを決済する取引です。証拠金を預けてレバレッジをかけた取引が可能で、多様な金融商品を取引対象とすることができます。',
    relatedTerms: ['差金決済', '証拠金取引', 'レバレッジ', 'FX (類似の仕組み)', '株価指数CFD', '商品CFD']
  },
  {
    id: 138,
    term: '限月',
    category: 'デリバティブ',
    description: '先物取引やオプション取引において、最終的な決済が行われる月、または権利行使ができる最終月のことです。取引できる限月は商品ごとに決められています。例えば、日経225先物では3月、6月、9月、12月が主要な限月です。',
    relatedTerms: ['先物取引', 'オプション取引', 'SQ', '最終売買日', '期近物', '期先物']
  },
  {
    id: 139,
    term: 'SQ',
    category: 'デリバティブ',
    description: '「特別清算指数」または「最終清算指数」と訳されます。株価指数先物取引や株価指数オプション取引などの限月取引において、最終的な決済を行うために算出される特別な清算価格（指数）のことです。SQ算出日は市場が大きく変動することがあります。',
    relatedTerms: ['先物取引', 'オプション取引', '限月', '最終決済', 'メジャーSQ', 'ミニSQ']
  },
  {
    id: 140,
    term: '原資産',
    category: 'デリバティブ',
    description: 'デリバティブ（金融派生商品）取引の対象となる元々の資産のことです。例えば、日経225先物取引の原資産は日経平均株価、個別株オプション取引の原資産は特定の個別株式となります。原資産の価格変動がデリバティブの価格に影響を与えます。',
    relatedTerms: ['デリバティブ', '先物取引', 'オプション取引', '株価指数', '個別株式', '為替', 'コモディティ']
  },

  // --- その他金融商品 ---
  {
    id: 141,
    term: 'コモディティ',
    category: 'その他金融商品',
    description: '「商品」と訳され、金、銀、プラチナなどの貴金属、原油、ガソリンなどのエネルギー、トウモロコシ、大豆、コーヒーなどの農産物といった、標準化され取引所で売買される現物商品のことです。先物取引やETF、投資信託などを通じて投資対象となります。',
    relatedTerms: ['金 (ゴールド)', '原油', '穀物', '貴金属', 'エネルギー', '農産物', '先物取引', 'ETF', '商品市況']
  },
  {
    id: 142,
    term: '金',
    category: 'その他金融商品',
    description: '代表的な貴金属であり、古くから価値の保存手段や装飾品として用いられてきました。インフレヘッジや「有事の金」として、経済不安時に買われる傾向があります。金地金、金貨、純金積立、金ETF、金先物など多様な投資方法があります。',
    relatedTerms: ['コモディティ', '貴金属', '安全資産', '有事の金', 'インフレヘッジ', '金ETF', '純金積立']
  },
  {
    id: 143,
    term: '原油',
    category: 'その他金融商品',
    description: '石油製品（ガソリン、灯油など）の原料となる、精製される前の状態の石油のことです。世界経済の動向や地政学的リスク、OPEC（石油輸出国機構）の生産方針などに価格が大きく影響されます。代表的な国際指標としてWTI原油やブレント原油があります。先物取引やETFなどで投資できます。',
    relatedTerms: ['コモディティ', 'エネルギー', 'WTI原油', 'ブレント原油', 'OPEC', '地政学リスク', '先物取引']
  },
  {
    id: 144,
    term: '不動産投資',
    category: 'その他金融商品',
    description: 'マンションやアパート、オフィスビル、土地などの不動産を購入し、賃料収入（インカムゲイン）や売却益（キャピタルゲイン）を得ることを目的とした投資です。実物不動産投資のほか、J-REIT（不動産投資信託）や不動産クラウドファンディングなど、間接的な投資方法もあります。',
    relatedTerms: ['J-REIT', 'インカムゲイン', 'キャピタルゲイン', '賃料収入', '不動産クラウドファンディング', '利回り物件']
  },
  {
    id: 145,
    term: '暗号資産',
    category: 'その他金融商品',
    description: '「仮想通貨」とも呼ばれ、インターネット上で取引される、暗号技術（ブロックチェーンなど）によって保護された電子的な資産です。代表的なものにビットコインやイーサリアムがあります。中央銀行のような管理主体が存在しない分散型の仕組みを持つものが多く、価格変動が非常に大きいことが特徴です。',
    relatedTerms: ['ビットコイン', 'イーサリアム', 'ブロックチェーン', '仮想通貨', '分散型台帳技術', 'ICO', 'NFT', 'DeFi']
  },
  {
    id: 146,
    term: 'ビットコイン',
    category: 'その他金融商品',
    description: '2009年に運用が開始された、世界で最初に登場した暗号資産（仮想通貨）です。サトシ・ナカモトと名乗る人物またはグループによって提唱されました。ブロックチェーン技術を基盤とし、中央集権的な管理者を必要としないP2P（ピアツーピア）ネットワークで取引されます。暗号資産の代表格として知られています。',
    relatedTerms: ['暗号資産', 'イーサリアム', 'ブロックチェーン', 'P2P', 'マイニング', 'サトシ・ナカモト']
  },
  {
    id: 147,
    term: 'イーサリアム',
    category: 'その他金融商品',
    description: 'ヴィタリック・ブテリン氏によって考案され、2015年に運用が開始された暗号資産（仮想通貨）およびそのプラットフォームの名称です。ビットコインと同様にブロックチェーン技術を基盤としますが、スマートコントラクト（契約の自動実行）機能を持ち、分散型アプリケーション（DApps）の開発プラットフォームとしても広く利用されています。',
    relatedTerms: ['暗号資産', 'ビットコイン', 'ブロックチェーン', 'スマートコントラクト', 'DApps', 'DeFi', 'NFT']
  },
  {
    id: 148,
    term: 'ソーシャルレンディング',
    category: 'その他金融商品',
    description: '「貸付型クラウドファンディング」とも呼ばれ、インターネットを通じて「お金を借りたい人や企業（借り手）」と「お金を貸したい人（投資家）」をマッチングするサービスです。投資家は、借り手が支払う利息をリターンとして期待できますが、貸し倒れリスクも存在します。',
    relatedTerms: ['クラウドファンディング', '貸付型クラウドファンディング', 'P2Pレンディング', '利回り', '貸し倒れリスク']
  },
  {
    id: 149,
    term: 'クラウドファンディング',
    category: 'その他金融商品',
    description: 'インターネットを通じて、不特定多数の人々から少額ずつ資金を集める仕組みの総称です。目的（新商品開発、社会貢献活動、事業立ち上げなど）やリターンの種類（寄付型、購入型、貸付型、投資型など）によって様々なタイプがあります。',
    relatedTerms: ['ソーシャルレンディング', '株式投資型クラウドファンディング', '寄付型', '購入型', '資金調達']
  },
  {
    id: 150,
    term: '外貨預金',
    category: 'その他金融商品',
    description: '日本の円ではなく、米ドルやユーロ、豪ドルなどの外国の通貨で預ける預金のことです。円預金よりも高い金利が期待できる場合があるほか、為替レートの変動によって為替差益（または為替差損）が生じる可能性があります。為替手数料がかかる点に注意が必要です。',
    relatedTerms: ['為替レート', '為替差益', '為替差損', '金利', 'FX', '円高・円安', '為替手数料']
  },
  // --- 市場・取引所関連 (Market & Exchange) --- (ID: 151 onwards)
  {
    id: 151,
    term: '東京証券取引所',
    category: '市場・取引所',
    description: '日本最大の証券取引所で、株式やデリバティブ（先物・オプション）などの売買が行われる市場を運営する株式会社日本取引所グループ（JPX）の中核企業です。「東証（とうしょう）」と略されます。日本の経済・金融の中心的な役割を担っています。',
    relatedTerms: ['JPX (日本取引所グループ)', 'プライム市場', 'スタンダード市場', 'グロース市場', '日経平均株価', 'TOPIX', '上場']
  },
  {
    id: 152,
    term: '東証プライム市場',
    category: '市場・取引所',
    description: '東京証券取引所の市場区分の一つで、2022年4月の市場再編により設置されました。多くの機関投資家の投資対象となりうる、高い時価総額（流動性）やガバナンス水準を持つ企業向けの市場です。旧東証一部上場企業が多く移行しました。',
    relatedTerms: ['東証スタンダード市場', '東証グロース市場', '東京証券取引所', '市場再編', '機関投資家', 'コーポレートガバナンス・コード']
  },
  {
    id: 153,
    term: '東証スタンダード市場',
    category: '市場・取引所',
    description: '東京証券取引所の市場区分の一つ。公開された市場における投資対象として十分な流動性とガバナンス水準を備えた企業向けの市場です。旧東証一部、二部、JASDAQスタンダードの企業が移行の対象となりました。',
    relatedTerms: ['東証プライム市場', '東証グロース市場', '東京証券取引所', '市場再編', 'JASDAQ']
  },
  {
    id: 154,
    term: '東証グロース市場',
    category: '市場・取引所',
    description: '東京証券取引所の市場区分の一つ。高い成長可能性を有する企業向けの市場です。事業実績の観点からは相対的にリスクが高いものの、将来の成長が期待される新興企業などが対象となります。旧マザーズ、JASDAQグロースの企業が移行の対象となりました。',
    relatedTerms: ['東証プライム市場', '東証スタンダード市場', '東京証券取引所', '市場再編', 'マザーズ', '新興企業', 'ベンチャー企業']
  },
  {
    id: 155,
    term: '名証',
    category: '市場・取引所',
    description: '名古屋証券取引所の略称。東京、大阪（現在はデリバティブ中心）に次ぐ日本の主要な証券取引所の一つで、名古屋市にあります。地元中部経済圏の企業を中心に上場しています。プレミア、メイン、ネクストの市場区分があります。',
    relatedTerms: ['東京証券取引所', '地方取引所', 'セントレックス (旧名証新興市場)']
  },
  {
    id: 156,
    term: '福証',
    category: '市場・取引所',
    description: '福岡証券取引所の略称。福岡市にある地方証券取引所の一つで、九州・沖縄経済圏の企業が中心に上場しています。本則市場とQ-Board（新興企業向け市場）があります。',
    relatedTerms: ['東京証券取引所', '地方取引所', 'Q-Board']
  },
  {
    id: 157,
    term: '札証',
    category: '市場・取引所',
    description: '札幌証券取引所の略称。札幌市にある地方証券取引所の一つで、北海道の企業が中心に上場しています。本則市場とアンビシャス（新興企業向け市場）があります。',
    relatedTerms: ['東京証券取引所', '地方取引所', 'アンビシャス']
  },
  {
    id: 158,
    term: 'PTS',
    category: '市場・取引所',
    description: '証券会社が運営する、証券取引所を介さずに株式などを売買できる私設の電子取引システムです。取引所の取引時間外（夜間など）でも取引できる場合があり、投資家にとっては取引機会の拡大に繋がります。SOR注文の対象となることもあります。',
    relatedTerms: ['東京証券取引所', '夜間取引', 'SOR注文', 'ダークプール', '代替取引システム']
  },
  {
    id: 159,
    term: 'ザラバ',
    category: '市場・取引所',
    description: '証券取引所において、寄り付き（取引開始時の板寄せ）と大引け（取引終了時の板寄せ）の間の、継続的に売買注文が付け合わされ取引が成立していく時間帯のことです。「ザラ場」とも書きます。この時間帯はオークション方式で価格が決定されます。',
    relatedTerms: ['寄り付き', '大引け', '板寄せ', 'オークション方式', '取引時間']
  },
  {
    id: 160,
    term: '寄り付き',
    category: '市場・取引所',
    description: '株式市場において、1日の取引が開始される最初の売買のこと、またはその時に成立した価格（始値）を指します。多くの注文が集まるため、板寄せ方式で価格が決定されることが一般的です。',
    relatedTerms: ['大引け', 'ザラバ', '板寄せ', '始値', '取引開始']
  },
  {
    id: 161,
    term: '大引け',
    category: '市場・取引所',
    description: '株式市場において、1日の取引が終了する最後の売買のこと、またはその時に成立した価格（終値）を指します。寄り付きと同様に、板寄せ方式で価格が決定されることが一般的です。',
    relatedTerms: ['寄り付き', 'ザラバ', '板寄せ', '終値', '取引終了', '引け間際']
  },
  {
    id: 162,
    term: '値幅制限',
    category: '市場・取引所',
    description: '株式市場において、1日の株価の変動幅を一定範囲内に制限する制度です。前日の終値を基準に、株価水準に応じて「ストップ高（上限）」と「ストップ安（下限）」が設定されます。過度な価格変動による市場の混乱を防ぎ、投資家を保護する目的があります。',
    relatedTerms: ['ストップ高', 'ストップ安', '制限値幅', 'サーキットブレーカー制度', '特別気配']
  },
  {
    id: 163,
    term: '特別気配',
    category: '市場・取引所',
    description: '株式市場で、買い注文または売り注文が一方的に多く、すぐに売買が成立しない場合に、証券取引所が表示する気配値のことです。例えば、ストップ高（安）水準まで買い（売り）注文が殺到した場合などに表示され、市場に注意を促します。',
    relatedTerms: ['気配値', 'ストップ高', 'ストップ安', '値幅制限', '板寄せ']
  },
  {
    id: 164,
    term: '取引時間',
    category: '市場・取引所',
    description: '証券取引所で株式などの売買が行われる時間帯のことです。東京証券取引所の場合、通常、午前（前場：ぜんば）と午後（後場：ごば）に分かれています。具体的な時間は取引所や市場によって異なります。PTSでは夜間取引も可能です。',
    relatedTerms: ['前場', '後場', 'ザラバ', '寄り付き', '大引け', 'PTS']
  },
  {
    id: 165,
    term: '立会外取引',
    category: '市場・取引所',
    description: '証券取引所の通常の取引時間（立会時間）外に行われる取引のことです。大口の取引や、特定の条件での取引などに利用されます。ToSTNeT市場などが代表例です。',
    relatedTerms: ['ToSTNeT市場', '時間外取引', '大口取引', 'ブロックトレード']
  },

  // --- 企業財務・会計 (Corporate Finance & Accounting) ---
  {
    id: 166,
    term: 'ROA',
    category: '企業財務・会計',
    description: '「総資産利益率」と訳されます。企業が保有する総資産（負債と自己資本の合計）を使って、どれだけ効率的に利益を上げているかを示す財務指標です。数値が高いほど、資産を有効活用して収益を上げていると評価されます。計算式は「当期純利益 ÷ 総資産 × 100 (%)」など。',
    relatedTerms: ['ROE', 'ROIC', '総資産', '当期純利益', '資本効率', '収益性', '事業利益率']
  },
  {
    id: 167,
    term: 'ROIC',
    category: '企業財務・会計',
    description: '「投下資本利益率」と訳されます。企業が事業活動のために投下した資本（有利子負債と自己資本の合計など）に対して、どれだけ効率的に利益を生み出しているかを示す指標です。ROAやROEと共に、企業の収益性や資本効率を測る上で重視されます。',
    relatedTerms: ['ROE', 'ROA', '投下資本', 'NOPAT (税引後営業利益)', 'WACC (加重平均資本コスト)', '資本効率']
  },
  {
    id: 168,
    term: 'EBITDA',
    category: '企業財務・会計',
    description: '「利払い前・税引き前・減価償却前利益」の略で、企業の現金ベースの収益力を示す指標の一つです。国際的な企業価値比較やM&Aの際などに用いられます。簡易的には「営業利益 ＋ 減価償却費」で算出されることが多いです。',
    relatedTerms: ['営業利益', '減価償却費', 'キャッシュフロー', '企業価値評価 (EV/EBITDA倍率)', 'M&A']
  },
  {
    id: 169,
    term: 'フリーキャッシュフロー',
    category: '企業財務・会計',
    description: '企業が事業活動で得たキャッシュ（営業キャッシュフロー）から、事業維持に必要な設備投資など（投資キャッシュフローの一部、または資本的支出）を差し引いた、企業が自由に使える現金の流れのことです。株主への配当、借入金の返済、新規事業への投資などの原資となります。企業価値評価にも用いられます。',
    relatedTerms: ['営業キャッシュフロー', '投資キャッシュフロー', '株主還元', '企業価値評価', 'DCF法', '資本的支出']
  },
  {
    id: 170,
    term: '営業キャッシュフロー',
    category: '企業財務・会計',
    description: '企業の本業である営業活動によって、一定期間にどれだけの現金（キャッシュ）が生み出されたか、または流出したかを示す数値です。キャッシュフロー計算書の一部で、企業の収益力や資金創出力の基本となります。プラスであることが望ましいとされます。',
    relatedTerms: ['投資キャッシュフロー', '財務キャッシュフロー', 'キャッシュフロー計算書', 'フリーキャッシュフロー', '運転資本']
  },
  {
    id: 171,
    term: '投資キャッシュフロー',
    category: '企業財務・会計',
    description: '企業が将来の成長のために、固定資産（工場、設備など）の取得や売却、有価証券の売買など、投資活動によってどれだけの現金が動いたかを示す数値です。キャッシュフロー計算書の一部です。通常、成長企業では設備投資などでマイナスになることが多いです。',
    relatedTerms: ['営業キャッシュフロー', '財務キャッシュフロー', 'キャッシュフロー計算書', '設備投資', '固定資産取得', '有価証券売買']
  },
  {
    id: 172,
    term: '財務キャッシュフロー',
    category: '企業財務・会計',
    description: '企業が営業活動や投資活動を支えるために、どのように資金調達し、また返済したかを示す数値です。キャッシュフロー計算書の一部で、借入金の増減、社債の発行・償還、株式の発行（増資）、配当金の支払いなどが含まれます。',
    relatedTerms: ['営業キャッシュフロー', '投資キャッシュフロー', 'キャッシュフロー計算書', '資金調達', '借入金返済', '増資', '配当金支払']
  },
  {
    id: 173,
    term: '売上高',
    category: '企業財務・会計',
    description: '企業が本業である営業活動（商品やサービスの販売・提供）によって得た収入の総額のことです。損益計算書の最初に記載され、企業の事業規模や成長性を示す基本的な指標です。',
    relatedTerms: ['営業利益', '売上総利益 (粗利)', '損益計算書', '増収増益', '事業規模']
  },
  {
    id: 174,
    term: '営業利益',
    category: '企業財務・会計',
    description: '企業が本業で稼いだ利益を示す数値です。売上高から売上原価を差し引いた「売上総利益（粗利）」から、さらに販売費及び一般管理費（人件費、広告費など）を差し引いて計算されます。企業の収益力を測る重要な指標です。',
    relatedTerms: ['売上高', '売上総利益', '経常利益', '損益計算書', '本業の儲け', '収益性']
  },
  {
    id: 175,
    term: '経常利益',
    category: '企業財務・会計',
    description: '企業が通常の事業活動全体から得た利益を示す数値です。営業利益に、受取利息や受取配当金などの「営業外収益」を加え、支払利息などの「営業外費用」を差し引いて計算されます。企業の総合的な収益力を示します。',
    relatedTerms: ['営業利益', '当期純利益', '損益計算書', '営業外収益', '営業外費用', '総合的な収益力']
  },
  {
    id: 176,
    term: '純利益',
    category: '企業財務・会計',
    description: '企業の一会計期間における最終的な利益を示す数値です。「当期純利益」とも呼ばれます。経常利益に、固定資産売却益などの「特別利益」を加え、災害損失などの「特別損失」を差し引き、さらに法人税などを支払った後の残りの利益です。株主への配当の原資となります。',
    relatedTerms: ['経常利益', 'EPS (1株当たり利益)', '損益計算書', '特別利益', '特別損失', '法人税等', '株主資本変動計算書']
  },
  {
    id: 177,
    term: '自己資本',
    category: '企業財務・会計',
    description: '企業の総資本のうち、株主からの出資金（資本金、資本剰余金）や、企業が過去に稼いだ利益の蓄積（利益剰余金）など、返済義務のない資金のことです。「純資産」とほぼ同義で使われます。企業の財務安定性を示す重要な指標です。',
    relatedTerms: ['他人資本 (負債)', '純資産', '貸借対照表', '自己資本比率', 'ROE (自己資本利益率)', '株主資本']
  },
  {
    id: 178,
    term: '他人資本',
    category: '企業財務・会計',
    description: '企業の総資本のうち、借入金や社債、買掛金など、将来返済または支払い義務のある資金のことです。「負債」とほぼ同義で使われます。自己資本と合わせて企業の資金調達源となります。',
    relatedTerms: ['自己資本 (純資産)', '負債', '貸借対照表', '有利子負債', 'D/Eレシオ']
  },
  {
    id: 179,
    term: '流動資産',
    category: '企業財務・会計',
    description: '企業が保有する資産のうち、1年以内に現金化されるか費用化されると見込まれる資産のことです。現金預金、受取手形、売掛金、有価証券（短期保有）、棚卸資産（商品・製品など）などが含まれます。企業の短期的な支払い能力を測る上で重要です。',
    relatedTerms: ['固定資産', '流動負債', '貸借対照表', '当座資産', '運転資本']
  },
  {
    id: 180,
    term: '固定資産',
    category: '企業財務・会計',
    description: '企業が保有する資産のうち、1年を超えて長期間にわたり使用または保有される資産のことです。土地、建物、機械設備などの「有形固定資産」、特許権やのれんなどの「無形固定資産」、長期投資有価証券などの「投資その他の資産」に分類されます。',
    relatedTerms: ['流動資産', '固定負債', '貸借対照表', '有形固定資産', '無形固定資産', '減価償却']
  },
  {
    id: 181,
    term: '流動負債',
    category: '企業財務・会計',
    description: '企業の負債のうち、1年以内に支払期限が到来するものです。支払手形、買掛金、短期借入金、未払法人税などが含まれます。企業の短期的な支払い能力（流動性）を測る上で、流動資産と比較されます。',
    relatedTerms: ['固定負債', '流動資産', '貸借対照表', '流動比率', '当座比率']
  },
  {
    id: 182,
    term: '固定負債',
    category: '企業財務・会計',
    description: '企業の負債のうち、支払期限が1年を超えて到来するものです。長期借入金、社債、退職給付引当金などが含まれます。企業の長期的な財務安定性を測る上で考慮されます。',
    relatedTerms: ['流動負債', '固定資産', '貸借対照表', '長期借入金', '社債']
  },
  {
    id: 183,
    term: '流動比率',
    category: '企業財務・会計',
    description: '企業の短期的な支払い能力（流動性）を測るための財務指標です。流動資産を流動負債で割って算出します（流動資産 ÷ 流動負債 × 100 (%)）。一般的に100％以上、理想的には200％程度が目安とされますが、業種によって異なります。',
    relatedTerms: ['当座比率', '流動資産', '流動負債', '安全性分析', '短期支払い能力']
  },
  {
    id: 184,
    term: '当座比率',
    category: '企業財務・会計',
    description: '企業の短期的な支払い能力を、流動比率よりも厳しく測るための財務指標です。流動資産の中でも特に現金化しやすい当座資産（現金預金、受取手形、売掛金、有価証券など）を流動負債で割って算出します。一般的に100％以上が目安とされます。',
    relatedTerms: ['流動比率', '当座資産', '流動負債', '安全性分析', '短期支払い能力', '棚卸資産（除く）']
  },
  {
    id: 185,
    term: '固定比率',
    category: '企業財務・会計',
    description: '企業の長期的な財務安定性を測るための財務指標です。固定資産が、返済義務のない自己資本でどれだけ賄われているかを示します。計算式は「固定資産 ÷ 自己資本 × 100 (%)」。この比率が低いほど、長期的な財務安定性が高いとされます。一般的に100％以下が望ましいとされます。',
    relatedTerms: ['固定長期適合率', '固定資産', '自己資本', '安全性分析', '長期財務安定性']
  },
  {
    id: 186,
    term: 'のれん',
    category: '企業財務・会計',
    description: 'M&A（企業の合併・買収）の際に、買収された企業の時価純資産額と実際の買収価格との差額のことです。買収された企業が持つブランド力、技術力、顧客基盤、ノウハウなど、貸借対照表には現れない無形の価値を反映します。会計上は無形固定資産として計上され、日本の会計基準では原則として20年以内の一定期間で償却されます（国際会計基準では非償却で毎期減損テスト）。',
    relatedTerms: ['M&A', '無形固定資産', '買収プレミアム', '減損会計', '企業価値評価', '超過収益力']
  },
  {
    id: 187,
    term: '減損会計',
    category: '企業財務・会計',
    description: '企業が保有する固定資産（土地、建物、機械設備、のれんなど）の収益性が低下し、投資額の回収が見込めなくなった場合に、その資産の帳簿価額を実質的な価値（回収可能価額）まで引き下げる会計処理のことです。資産の過大評価を防ぎ、財務諸表の信頼性を高めることを目的とします。',
    relatedTerms: ['固定資産', 'のれん', '帳簿価額', '回収可能価額', '特別損失', '資産評価']
  },
  {
    id: 188,
    term: '棚卸資産',
    category: '企業財務・会計',
    description: '企業が販売目的で保有している商品、製品、半製品、仕掛品、原材料などの総称です。「在庫」とも呼ばれます。貸借対照表では流動資産に分類されます。棚卸資産の評価方法（先入先出法、平均法など）や、回転期間（どれくらいの期間で在庫が入れ替わるか）などが経営分析のポイントとなります。',
    relatedTerms: ['在庫', '流動資産', '売上原価', '棚卸資産回転期間', '棚卸資産評価損', '適正在庫']
  },
  {
    id: 189,
    term: '引当金',
    category: '企業財務・会計',
    description: '将来発生する可能性が高い特定の費用や損失に備えて、当期の費用または損失としてあらかじめ計上しておく見積金額のことです。貸倒引当金、賞与引当金、退職給付引当金、修繕引当金などがあります。企業の財務状況をより正確に表すために設定されます。',
    relatedTerms: ['貸倒引当金', '賞与引当金', '退職給付引当金', '負債の部', '費用計上', '保守主義の原則']
  },
  {
    id: 190,
    term: 'セグメント情報',
    category: '企業財務・会計',
    description: '企業が複数の異なる事業分野（セグメント）で活動している場合に、それぞれの事業分野ごとの売上高、利益（または損失）、資産などの財務情報を開示するものです。投資家が企業の多角的な事業内容や各事業の収益性を理解し、より詳細な投資判断を行うために役立ちます。',
    relatedTerms: ['事業セグメント', '多角化経営', '有価証券報告書', '決算短信', '経営分析']
  },

  // --- 注文方法 ---
  {
    id: 191,
    term: '成行注文',
    category: '注文方法',
    description: '株式やFXなどの金融商品を売買する際に、値段を指定せずに注文する方法です。「いくらでもいいから買いたい（売りたい）」という意思表示となり、取引の成立（約定）を最優先します。売買が成立しやすい反面、市場の状況によっては予期せぬ価格で約定するリスク（スリッページ）もあります。',
    relatedTerms: ['指値注文', '約定', 'スリッページ', '板寄せ', 'ザラバ', '売買成立優先']
  },
  {
    id: 192,
    term: '指値注文',
    category: '注文方法',
    description: '株式やFXなどの金融商品を売買する際に、希望する価格を指定して注文する方法です。買い注文の場合は「指定した価格以下」、売り注文の場合は「指定した価格以上」でなければ約定しません。希望通りの価格で取引できる可能性がある一方、市場価格が指定した価格に達しない場合は約定しないこともあります。',
    relatedTerms: ['成行注文', '逆指値注文', '約定', '価格優先', '注文期限']
  },
  {
    id: 193,
    term: '逆指値注文',
    category: '注文方法',
    description: '通常の指値注文とは逆に、現在の市場価格よりも不利な価格（買い注文なら現在より高い価格、売り注文なら現在より低い価格）を指定する注文方法です。主に、損失を限定するための「損切り（ストップロス）」や、トレンドに乗って利益を拡大するための「トレンドフォロー（ブレイクアウト狙い）」に利用されます。指定価格に達すると成行注文として執行されることが多いです。',
    relatedTerms: ['指値注文', '損切り', 'トレンドフォロー', 'ブレイクアウト', 'OCO注文', 'トリガー価格']
  },
  {
    id: 194,
    term: 'OCO注文',
    category: '注文方法',
    description: '「オーシーオーちゅうもん」と読みます。2つの異なる注文（例えば、利益確定のための指値注文と、損失限定のための逆指値注文）を同時に出し、一方が約定するともう一方の注文が自動的にキャンセルされる注文方法です。利益の確保と損失の限定を同時に設定したい場合に便利です。',
    relatedTerms: ['指値注文', '逆指値注文', 'IFDO注文', '利益確定', '損切り', '自動キャンセル']
  },
  {
    id: 195,
    term: 'IFD注文',
    category: '注文方法',
    description: '「イフダンちゅうもん」と読みます。「もし～ならば～する」という意味で、最初の注文（親注文）が約定したら、次の注文（子注文）が自動的に有効になる注文方法です。例えば、新規の買い注文が約定したら、その銘柄の利益確定のための売り注文を自動で出す、といった使い方ができます。',
    relatedTerms: ['IFDO注文', 'OCO注文', '連続注文', '新規注文', '決済注文']
  },
  {
    id: 196,
    term: 'IFDO注文',
    category: '注文方法',
    description: '「イフダンオーシーオーちゅうもん」と読みます。IFD注文とOCO注文を組み合わせたもので、最初の注文（親注文）が約定したら、次にOCO注文（利益確定の指値注文と損失限定の逆指値注文など）が自動的に有効になる注文方法です。新規注文と同時に、その決済注文（利益確定と損切り）を一度に設定できます。',
    relatedTerms: ['IFD注文', 'OCO注文', '連続注文', '自動売買', 'リスク管理']
  },
  {
    id: 197,
    term: 'トレール注文',
    category: '注文方法',
    description: '株価や為替レートの変動に合わせて、逆指値の価格（ストップ価格）が自動的に有利な方向へ追随（トレール）していく注文方法です。価格が有利に動けばストップ価格も追随し、不利に動いた場合はその時点のストップ価格で逆指値注文が執行されます。利益を伸ばしつつ、損失を限定するのに役立ちます。',
    relatedTerms: ['逆指値注文', '利益確定', '損切り', 'トレンドフォロー', '自動追尾']
  },
  {
    id: 198,
    term: '約定',
    category: '注文方法',
    description: '株式やFXなどの金融取引において、投資家が出した買い注文または売り注文が市場で成立することです。「やくじょう」と読みます。注文が約定すると売買契約が成立し、定められた期日に決済（株式や代金の受け渡し）が行われます。',
    relatedTerms: ['未約定', '注文', '決済', '約定価格', '約定日', '受渡日']
  },
  {
    id: 199,
    term: '未約定',
    category: '注文方法',
    description: '投資家が出した買い注文または売り注文が、まだ市場で成立していない状態のことです。「みやくじょう」と読みます。指値注文で指定した価格に市場価格が達しない場合や、注文の有効期限が切れた場合などに発生します。',
    relatedTerms: ['約定', '注文', '指値注文', '有効期限', 'キャンセル']
  },
  {
    id: 200,
    term: 'ティック',
    category: '注文方法',
    description: '金融商品の価格が変動する際の最小の値動き単位のことです。例えば、株価が1円単位で動く場合、1ティック＝1円となります。FXでは、通貨ペアによってティックの単位（例：0.1銭）が異なります。また、約定した個々の取引を指すこともあります（ティックデータ）。',
    relatedTerms: ['値動き', '呼値', '最小変動単位', 'ティックデータ', 'スキャルピング']
  },
  {
    id: 201,
    term: 'スリッページ',
    category: '注文方法',
    description: '成行注文や逆指値注文などを出した際に、注文した価格と実際に約定した価格との間に生じるズレのことです。市場価格が急激に変動しているときや、流動性が低い場合に発生しやすくなります。投資家にとって有利な方向にズレることも不利な方向にズレることもあります。',
    relatedTerms: ['成行注文', '逆指値注文', '約定価格', '流動性', '価格変動', '許容スリッページ']
  },
  {
    id: 202,
    term: 'GTC',
    category: '注文方法',
    description: '「キャンセルされるまで有効」という意味の注文の有効期間指定の一つです。投資家が明示的に注文をキャンセルするか、約定するまで、その注文が有効であり続けるという指定です。ただし、証券会社によっては最大有効期間（例：数週間～数ヶ月）が設定されている場合があります。',
    relatedTerms: ['注文有効期間', '当日限り注文', '週末まで有効', '指値注文']
  },
  {
    id: 203,
    term: 'IOC',
    category: '注文方法',
    description: '「即時またはキャンセル」という意味の注文執行条件の一つです。注文を出した時点で、指定した価格またはそれより有利な価格で約定できる数量だけを即座に約定させ、約定しなかった残りの数量は自動的にキャンセルされるという条件です。',
    relatedTerms: ['FOK', '執行条件', '一部約定', '即時約定']
  },
  {
    id: 204,
    term: 'FOK',
    category: '注文方法',
    description: '「全数量執行または全数量キャンセル」という意味の注文執行条件の一つです。注文を出した時点で、指定した数量のすべてが約定できる場合にのみ執行し、一部でも約定できない場合は全数量をキャンセルするという条件です。IOC注文と異なり、一部約定は認められません。',
    relatedTerms: ['IOC', '執行条件', '全数量約定', '即時約定']
  },
  {
    id: 205,
    term: '追証',
    category: '注文方法',
    description: '信用取引やFX取引（外国為替証拠金取引）などで、相場の変動により評価損が発生し、預託している委託保証金や証拠金が、維持しなければならない最低限度（維持率）を下回った場合に、追加で差し入れなければならない保証金のことです。「追加保証金」とも言います。指定された期日までに入金できない場合、強制的に保有ポジションが決済されることがあります。',
    relatedTerms: ['信用取引', 'FX', '証拠金', '委託保証金', '維持率', '強制決済', 'ロスカット']
  },
  // --- アノマリー・市場心理 (Anomaly & Market Sentiment) ---
  {
    id: 206,
    term: 'アノマリー',
    category: 'アノマリー・市場心理',
    description: '現代の金融理論や効率的市場仮説では説明が難しい、経験的に観測される株式市場などの規則性や株価の変動パターンのことです。「1月効果」や「週末効果」、「低PER効果」などが知られています。科学的根拠が明確でないものも多く、必ずしも再現性があるとは限りませんが、市場参加者の行動に影響を与えることがあります。',
    relatedTerms: ['効率的市場仮説', '行動ファイナンス', '1月効果', 'セルインメイ', '曜日効果', '季節性', '経験則']
  },
  {
    id: 207,
    term: '1月効果',
    category: 'アノマリー・市場心理',
    description: '株式市場において、1月の株価収益率が他の月と比較して高くなる傾向があるとされるアノマリーの一つです。特に小型株で顕著に見られると言われることがあります。年末の税金対策売りからの反動買いや、新年への期待感などが要因として挙げられることがありますが、明確な理由は定かではありません。',
    relatedTerms: ['アノマリー', '小型株効果', '季節性アノマリー', '年末ラリー', '税金対策']
  },
  {
    id: 208,
    term: 'セルインメイ',
    category: 'アノマリー・市場心理',
    description: '「5月に株を売れ（そして9月まで市場に戻ってくるな）」という内容の、欧米の株式市場の格言に基づいたアノマリーです。5月から夏場にかけて株価が軟調になりやすく、秋以降に再び上昇する傾向があるという経験則を指します。ただし、毎年当てはまるわけではありません。',
    relatedTerms: ['アノマリー', '季節性アノマリー', '夏枯れ相場', 'ハロウィン効果']
  },
  {
    id: 209,
    term: '節分天井彼岸底',
    category: 'アノマリー・市場心理',
    description: '日本の株式市場におけるアノマリーの一つで、株価が2月の節分の頃に高値（天井）をつけ、3月の春分の彼岸の頃に安値（底）をつける傾向があるという経験則です。明確な根拠はありませんが、市場で語られることがあります。',
    relatedTerms: ['アノマリー', '季節性アノマリー', '相場格言', '日本株']
  },
  {
    id: 210,
    term: '恐怖指数',
    category: 'アノマリー・市場心理',
    description: 'シカゴ・オプション取引所（CBOE）が、S&P500種株価指数のオプション取引の価格変動をもとに算出・公表している指数です。「VIX指数」とも呼ばれます。市場参加者の今後30日間の相場変動に対する予測（期待ボラティリティ）を反映し、一般的に数値が高いほど市場の不確実性が高く、投資家が先行きに強い不安（恐怖）を感じている状態を示します。',
    relatedTerms: ['ボラティリティ', 'S&P500', 'オプション取引', '市場心理', 'リスクオフ', 'CBOE', '日経VI']
  },
  {
    id: 211,
    term: '狼狽売り',
    category: 'アノマリー・市場心理',
    description: '予期せぬ悪材料の出現や相場の急落などが発生した際に、投資家が恐怖心や不安感から冷静な判断力を失い、保有している株式などを慌てて売却してしまうことです。しばしば相場の下落をさらに加速させる要因となり、セリングクライマックスに繋がることもあります。',
    relatedTerms: ['追証', 'セリングクライマックス', 'オーバーシュート', 'センチメント', '暴落', '底値圏']
  },
  {
    id: 212,
    term: '押し目買い',
    category: 'アノマリー・市場心理',
    description: '上昇トレンドにある株価や為替レートが、一時的に下落した（押し目を作った）タイミングを狙って買いを入れる投資手法です。トレンドが継続することを見込んで、比較的有利な価格で購入しようとするものです。ただし、押し目と見えたものがトレンド転換の始まりである可能性もあるため注意が必要です。',
    relatedTerms: ['戻り売り', '上昇トレンド', 'サポートライン', 'トレンドフォロー', '逆張り（短期的な）']
  },
  {
    id: 213,
    term: '戻り売り',
    category: 'アノマリー・市場心理',
    description: '下降トレンドにある株価や為替レートが、一時的に上昇した（戻りを見せた）タイミングを狙って売りを入れる投資手法です。トレンドが継続することを見込んで、比較的有利な価格で売却（または空売り）しようとするものです。',
    relatedTerms: ['押し目買い', '下降トレンド', 'レジスタンスライン', 'トレンドフォロー', '逆張り（短期的な）']
  },
  {
    id: 214,
    term: 'ブルマーケット',
    category: 'アノマリー・市場心理',
    description: '長期間にわたって株価などの市場価格が上昇傾向にある強い相場のことです。「強気相場」とも言います。「ブル（雄牛）」が角を下から上へ突き上げる仕草が、力強い上昇を連想させることから名付けられました。投資家心理も楽観的になりやすいです。',
    relatedTerms: ['ベアマーケット', '強気相場', '上昇トレンド', 'ダウ理論', '相場サイクル', '楽観相場']
  },
  {
    id: 215,
    term: 'ベアマーケット',
    category: 'アノマリー・市場心理',
    description: '長期間にわたって株価などの市場価格が下落傾向にある弱い相場のことです。「弱気相場」とも言います。「ベア（熊）」が爪を上から下へ振り下ろす仕草が、力ない下落を連想させることから名付けられました。投資家心理も悲観的になりやすいです。',
    relatedTerms: ['ブルマーケット', '弱気相場', '下降トレンド', 'ダウ理論', '相場サイクル', '悲観相場']
  },
  {
    id: 216,
    term: 'コンセンサス',
    category: 'アノマリー・市場心理',
    description: '市場参加者の間で共有されている、特定の経済指標の予測値や企業の業績見通し、株価の目標水準などについての平均的な意見や予測のことです。「市場コンセンサス」とも言います。発表された実際の数値がコンセンサスから大きく乖離すると、市場が大きく反応することがあります。',
    relatedTerms: ['アナリスト予測', '業績予想', 'サプライズ', '市場織り込み済み', '期待値']
  },
  {
    id: 217,
    term: 'センチメント',
    category: 'アノマリー・市場心理',
    description: '市場参加者全体の心理状態や市場に対する雰囲気、ムードのことです。「市場心理」とも訳されます。強気（楽観的）か弱気（悲観的）かといった市場の総体的な感情を表し、価格変動に影響を与えることがあります。投資家サーベイや特定の指標（例：恐怖指数）で測られることもあります。',
    relatedTerms: ['市場心理', '恐怖指数', '投資家心理', '強気', '弱気', '楽観', '悲観']
  },
  {
    id: 218,
    term: 'オーバーシュート',
    category: 'アノマリー・市場心理',
    description: '株価や為替レートなどが、経済のファンダメンタルズから見て適正と考えられる水準を一時的に大きく超えて変動することです。市場参加者の過度な期待や悲観、投機的な動きなどによって発生しやすく、その後、適正水準に戻る動き（反動）が見られることがあります。',
    relatedTerms: ['ファンダメンタルズ', '投機', 'バブル', '暴落', '行き過ぎた変動', '反動']
  },
  {
    id: 219,
    term: 'ブラック・スワン',
    category: 'アノマリー・市場心理',
    description: '事前にほとんど予想できず、発生すると市場や経済に極めて大きな衝撃を与える出来事のことです。ナシーム・ニコラス・タレブ氏の著書で広まった概念で、「ありえない」と思われていたことが現実に起こることを指します。リーマンショックや大規模な自然災害などが例として挙げられることがあります。',
    relatedTerms: ['テールリスク', '市場の非効率性', '予測不可能', '危機管理', 'リーマンショック']
  },
  {
    id: 220,
    term: 'ハーディング効果',
    category: 'アノマリー・市場心理',
    description: '「群集行動」とも訳され、個人が自分自身の判断よりも、周囲の多くの人々の行動や意見に同調し、同じような行動をとってしまう心理現象のことです。株式市場においては、他の投資家の買い（売り）に追随して売買する行動などがこれに該当し、バブルの形成や暴落の一因となることがあります。',
    relatedTerms: ['行動ファイナンス', '市場心理', 'バブル経済', '追随買い', '狼狽売り', '群集心理', '合理的判断の欠如']
  },

  // --- フィンテック・その他 (FinTech & Others) ---
  {
    id: 221,
    term: 'フィンテック',
    category: 'フィンテック・その他',
    description: '金融（Finance）と技術（Technology）を組み合わせた造語です。IT技術（AI、ビッグデータ、ブロックチェーン、モバイル技術など）を活用して、決済、送金、資産運用、資金調達、保険など、従来にはなかった革新的で利便性の高い金融サービスや仕組みを生み出す動き、またはそれらのサービス自体を指します。',
    relatedTerms: ['ロボアドバイザー', 'ブロックチェーン', 'AI (人工知能)', 'APIエコノミー', 'モバイル決済', 'クラウドファンディング', '仮想通貨 (暗号資産)']
  },
  {
    id: 222,
    term: 'ロボアドバイザー (Robo-advisor)',
    category: 'フィンテック・その他',
    description: 'ロボット（アルゴリズム）が、インターネットを通じて投資家に対して資産運用のアドバイスや実際の運用を行ってくれるサービスです。いくつかの質問に答えることで、個人のリスク許容度や目標に合わせたポートフォリオを提案し、自動で売買やリバランスを行ってくれるものもあります。低コストで手軽に始められるのが特徴です。',
    relatedTerms: ['フィンテック', 'アルゴリズム取引', 'ポートフォリオ', 'リバランス', 'ETF', '資産運用自動化']
  },
  {
    id: 223,
    term: 'APIエコノミー',
    category: 'フィンテック・その他',
    description: '企業が自社のサービスやデータの機能をAPI（Application Programming Interface）として外部に公開し、他の企業や開発者がそれを利用して新たなサービスやビジネスを創出する経済圏のことです。金融分野では、銀行APIの公開により、フィンテック企業が新しい金融サービス（例：家計簿アプリとの連携）を提供できるようになりました。',
    relatedTerms: ['フィンテック', 'API', 'オープンバンキング', 'データ連携', 'プラットフォームビジネス']
  },
  {
    id: 224,
    term: 'ブロックチェーン',
    category: 'フィンテック・その他',
    description: '「分散型台帳技術」とも呼ばれ、取引記録などのデータを「ブロック」という単位で生成し、それらを時系列に沿って鎖（チェーン）のように連結して記録・管理する技術です。データはネットワーク上の多数の参加者によって共有・検証されるため、改ざんが極めて困難で透明性が高いという特徴があります。暗号資産（仮想通貨）の中核技術として知られています。',
    relatedTerms: ['暗号資産 (仮想通貨)', 'ビットコイン', 'イーサリアム', '分散型台帳技術', 'スマートコントラクト', '非中央集権']
  },
  {
    id: 225,
    term: 'スマートコントラクト',
    category: 'フィンテック・その他',
    description: 'あらかじめ設定された契約条件やルールに従って、取引や手続きを自動的に実行するプログラムのことです。ブロックチェーン技術を基盤として実装されることが多く、契約の履行を仲介者なしに確実かつ効率的に行うことを目指します。DeFi（分散型金融）などで活用されています。',
    relatedTerms: ['ブロックチェーン', 'イーサリアム', 'DeFi (分散型金融)', '契約自動化', 'プログラム可能契約']
  },
  {
    id: 226,
    term: 'ESG投資',
    category: 'フィンテック・その他',
    description: '環境（Environment）、社会（Social）、企業統治（Governance）の3つの観点を重視して企業を評価し、投資先を選定する投資手法です。財務情報だけでなく、これらの非財務情報も考慮することで、企業の持続的な成長や社会全体の持続可能性への貢献を目指します。長期的なリターンを期待する投資家から注目されています。',
    relatedTerms: ['SRI (社会的責任投資)', 'SDGs (持続可能な開発目標)', 'CSR (企業の社会的責任)', 'インパクト投資', 'サステナビリティ', '非財務情報']
  },
  {
    id: 227,
    term: 'SRI',
    category: 'フィンテック・その他',
    description: '「社会的責任投資」と訳されます。財務的なリターンだけでなく、倫理的、社会的、環境的な側面を考慮して投資先を選定する投資手法です。特定の倫理基準（例：武器製造やギャンブルに関わらない）に基づいて投資対象から除外する（ネガティブスクリーニング）などの方法があります。ESG投資の先駆けとも言えます。',
    relatedTerms: ['ESG投資', '倫理的投資', 'ネガティブスクリーニング', 'ポジティブスクリーニング', 'サステナビリティ']
  },
  {
    id: 228,
    term: 'インパクト投資',
    category: 'フィンテック・その他',
    description: '財務的なリターンと並行して、貧困、教育、環境問題などの社会的・環境的課題の解決に貢献する、測定可能なポジティブな「インパクト」を生み出すことを意図した投資です。ESG投資やSRIよりも、より積極的な社会貢献を追求する点が特徴です。',
    relatedTerms: ['ESG投資', 'SRI', '社会的企業', '社会貢献', '測定可能なインパクト']
  },
  {
    id: 229,
    term: 'オルタナティブ投資',
    category: 'フィンテック・その他',
    description: '株式や債券といった伝統的な投資対象（アセットクラス）以外の新しい投資対象や投資手法の総称です。ヘッジファンド、プライベートエクイティ、不動産、コモディティ（商品）、インフラ、美術品、暗号資産などが含まれます。伝統的資産とは異なる値動きをすることが期待され、ポートフォリオの分散効果を高める目的で利用されることがあります。',
    relatedTerms: ['ヘッジファンド', 'プライベートエクイティ', 'コモディティ', '不動産投資', '暗号資産', '分散投資', 'ポートフォリオ']
  },
  {
    id: 230,
    term: 'ヘッジファンド',
    category: 'フィンテック・その他',
    description: '様々な運用戦略（例：空売り、レバレッジ、デリバティブ活用など）を駆使し、市場の状況に関わらず絶対的なリターンを追求することを目指す私募の投資ファンドです。一般的に、富裕層や機関投資家を対象としています。オルタナティブ投資の一つです。',
    relatedTerms: ['オルタナティブ投資', '絶対収益追求型', '私募ファンド', 'ロングショート戦略', 'アービトラージ']
  },
  {
    id: 231,
    term: 'プライベートエクイティ',
    category: 'フィンテック・その他',
    description: '未公開企業の株式（エクイティ）に投資するファンド、またはその投資行為自体を指します。投資対象は、成長初期のベンチャー企業から、経営再建を目指す企業、MBO（経営陣買収）を行う企業など多岐にわたります。企業価値を高めた後に、IPO（新規株式公開）や他社への売却（M&A）によって利益を得ることを目指します。',
    relatedTerms: ['オルタナティブ投資', '未公開株', 'ベンチャーキャピタル', 'MBO', 'LBO', 'バイアウトファンド']
  },
  {
    id: 232,
    term: 'エンジェル投資家',
    category: 'フィンテック・その他',
    description: '創業間もないスタートアップ企業や起業家に対して、資金を提供する個人投資家のことです。資金提供だけでなく、経営に関するアドバイスや人脈紹介など、成長を支援する役割も担うことがあります。ハイリスク・ハイリターンな投資ですが、将来有望な企業を初期段階から支援する魅力があります。',
    relatedTerms: ['ベンチャーキャピタル', 'スタートアップ', 'シードマネー', '未公開株', 'ハイリスク・ハイリターン']
  },
  {
    id: 233,
    term: 'ベンチャーキャピタル',
    category: 'フィンテック・その他',
    description: '高い成長可能性を持つ未上場のスタートアップ企業（ベンチャー企業）に対して、主に出資（株式取得）の形で投資を行う会社や組織のことです。投資先の企業価値が向上した後に、株式売却（IPOやM&A）によってキャピタルゲインを得ることを目的とします。',
    relatedTerms: ['エンジェル投資家', 'スタートアップ', '未公開株', 'IPO', 'M&A', 'キャピタルゲイン']
  },
  {
    id: 234,
    term: 'グリーンボンド',
    category: 'フィンテック・その他',
    description: '企業や地方公共団体などが、地球温暖化対策や再生可能エネルギー事業など、環境改善効果のあるプロジェクト（グリーンプロジェクト）への資金調達のために発行する債券のことです。ESG投資の一環として注目されています。',
    relatedTerms: ['ESG投資', 'SDGs債', 'サステナブルファイナンス', '債券', '環境プロジェクト']
  },
  {
    id: 235,
    term: 'マイクロファイナンス',
    category: 'フィンテック・その他',
    description: '貧困層や低所得者層など、従来の金融機関のサービスを受けにくい人々に対して、小規模な融資（マイクロクレジット）や貯蓄、保険などの金融サービスを提供する取り組みの総称です。途上国の経済的自立支援や貧困削減を目的としています。グラミン銀行などが有名です。',
    relatedTerms: ['マイクロクレジット', '社会的企業', '貧困削減', 'インパクト投資', 'グラミン銀行']
  },

  // --- 法律・規制 (Law & Regulation) ---
  {
    id: 236,
    term: '金融商品取引法',
    category: '法律・規制',
    description: '投資家保護や金融・資本市場の公正性・透明性の確保などを目的として、金融商品の取引全般を包括的に規制する日本の法律です。「金商法（きんしょうほう）」と略されます。有価証券の発行・流通に関する情報開示制度、金融商品取引業者の規制、不公正取引（インサイダー取引など）の禁止などが定められています。',
    relatedTerms: ['インサイダー取引', 'ディスクロージャー', '証券取引法 (旧)', '金融庁', '投資家保護', '不公正取引']
  },
  {
    id: 237,
    term: 'インサイダー取引',
    category: '法律・規制',
    description: '上場会社の役職員や大株主などの会社関係者、およびこれらの者から未公表の重要事実（新株発行、合併、業績予想の大幅な変更など）の伝達を受けた情報受領者が、その情報が公表される前に、その会社の株式などを売買し利益を得たり損失を回避したりする不公正な取引のことです。金融商品取引法で厳しく禁止されています。',
    relatedTerms: ['金融商品取引法', '未公表の重要事実', '内部者情報', '市場の公正性', '課徴金', '情報伝達規制']
  },
  {
    id: 238,
    term: '金融庁',
    category: '法律・規制',
    description: '日本の金融制度の企画・立案、金融機関の検査・監督、証券取引等の監視などを行う内閣府の外局です。金融システムの安定、預金者・保険契約者・投資家などの保護、公正かつ円滑な金融の実現を目的としています。',
    relatedTerms: ['証券取引等監視委員会', '日本銀行', '金融行政', '検査・監督', '投資家保護']
  },
  {
    id: 239,
    term: '証券取引等監視委員会',
    category: '法律・規制',
    description: '金融庁に設置されている合議制の機関で、日本の資本市場における不正取引（インサイダー取引、相場操縦など）の監視、金融商品取引業者などの検査、違反行為に対する課徴金納付命令の勧告などを行っています。「SESC（セスク）」と略されます。市場の公正性と透明性の確保を目的としています。',
    relatedTerms: ['金融庁', 'インサイダー取引', '相場操縦', '不公正取引', '市場監視', '課徴金']
  },
  {
    id: 240,
    term: '日本証券業協会',
    category: '法律・規制',
    description: '日本の証券会社やその他の金融商品取引業者を会員とする自主規制機関です。金融商品取引法に基づき、投資家の保護や証券取引の公正・円滑化を図るため、自主規制ルールの制定、会員に対する監査・指導、証券知識の普及・啓発などを行っています。「日証協（にっしょうきょう）」と略されます。',
    relatedTerms: ['自主規制機関', '証券会社', '金融商品取引業者', '投資家保護', '証券外務員資格']
  },
  {
    id: 241,
    term: '投資者保護基金',
    category: '法律・規制',
    description: '証券会社が経営破綻した場合などに、投資家が預けていた有価証券や金銭の返還が困難になった際に、一定の範囲内で投資家の資産を補償する制度です。日本投資者保護基金と農林水産関連の基金があります。投資家が安心して証券取引を行えるようにするためのセーフティネットの一つです。',
    relatedTerms: ['証券会社破綻', 'セーフティネット', '顧客資産保護', '分別管理', '補償限度額']
  },
  {
    id: 242,
    term: 'コンプライアンス',
    category: '法律・規制',
    description: '「法令遵守」と訳されますが、単に法律を守るだけでなく、社会規範や企業倫理、社内規程なども含めた幅広いルールを遵守して企業活動を行うことを意味します。金融機関においては、投資家保護や市場の信頼性確保のために特に重要視され、コンプライアンス体制の整備が求められます。',
    relatedTerms: ['法令遵守', '企業倫理', '内部統制', 'リスク管理', 'コーポレートガバナンス', '金融庁']
  },
  {
    id: 243,
    term: 'ディスクロージャー',
    category: '法律・規制',
    description: '企業などが、投資家やその他の利害関係者に対して、経営内容や財務状況などの情報を開示することです。「情報開示」とも言います。投資家が適切な投資判断を行うために不可欠であり、金融商品取引法などで制度化されています。有価証券報告書や決算短信などが代表的な開示資料です。',
    relatedTerms: ['情報開示', '有価証券報告書', '決算短信', '適時開示', '透明性', 'フェアディスクロージャー']
  },
  {
    id: 244,
    term: '適合性の原則',
    category: '法律・規制',
    description: '金融商品取引業者が、顧客に対して金融商品の勧誘や販売を行う際に、顧客の知識、経験、財産の状況、投資目的などを十分に把握し、それらに適合した商品を勧めるべきであるという原則です。投資家保護の観点から金融商品取引法に定められています。',
    relatedTerms: ['投資家保護', '金融商品取引法', '説明義務', '顧客本位の業務運営', 'リスク許容度']
  },
  {
    id: 245,
    term: '分別管理',
    category: '法律・規制',
    description: '証券会社などの金融商品取引業者が、自社の固有財産と、顧客から預かった有価証券や金銭などの資産を明確に区分して管理することです。万が一、金融商品取引業者が破綻した場合でも、顧客の資産が保全されるようにするための重要な措置で、金融商品取引法で義務付けられています。',
    relatedTerms: ['投資者保護基金', '顧客資産保護', '信託保全', '金融商品取引法', '倒産隔離']
  },
  {
    id: 246,
    term: 'マネーロンダリング',
    category: '法律・規制',
    description: '「資金洗浄」とも訳され、犯罪などによって不正に得た資金（汚れたお金）を、正当な取引で得た資金であるかのように見せかけるために、金融機関の口座などを利用して複雑な取引を繰り返したり、海外に送金したりする行為のことです。国際的な組織犯罪対策として、各国で厳しい規制が行われています。',
    relatedTerms: ['FATF (金融活動作業部会)', 'AML (アンチ・マネーロンダリング)', 'テロ資金供与対策', '犯罪収益移転防止法', '疑わしい取引の届出']
  },
  {
    id: 247,
    term: 'FATF',
    category: '法律・規制',
    description: '「金融活動作業部会」と訳されます。マネーロンダリング対策やテロ資金供与対策（AML/CFT）に関する国際的な基準（FATF勧告）を策定し、その履行状況を各国相互に審査する政府間機関です。1989年にG7サミットの経済宣言を受けて設立されました。',
    relatedTerms: ['マネーロンダリング', 'テロ資金供与対策', 'AML (アンチ・マネーロンダリング)', '国際協調', '相互審査']
  },
  {
    id: 248,
    term: 'バーゼル合意',
    category: '法律・規制',
    description: '国際的に活動する銀行の健全性を維持し、金融システムの安定化を図るために、バーゼル銀行監督委員会が策定した自己資本比率などに関する国際的な統一基準です。これまでにバーゼルI、II、IIIと改定・強化が重ねられています。',
    relatedTerms: ['自己資本比率', '銀行監督', '金融システム安定化', 'BIS規制', 'リスクアセット']
  },
  {
    id: 249,
    term: 'SEC',
    category: '法律・規制',
    description: '「米国証券取引委員会」と訳されます。米国の連邦政府機関の一つで、投資家保護、公正かつ効率的な市場の維持、資本形成の促進を目的として、証券取引や金融市場を監督・規制しています。日本の金融庁・証券取引等監視委員会に相当する役割を担っています。',
    relatedTerms: ['金融庁', '証券取引等監視委員会', '米国株式市場', '証券規制', 'インサイダー取引']
  },
  {
    id: 250,
    term: 'FINRA',
    category: '法律・規制',
    description: '「金融取引業規制機構」と訳されます。米国の証券業界における最大の自主規制機関です。証券会社や証券外務員の登録・監督、取引ルールの設定・執行、投資家教育などを行っています。SECの監督下で活動しています。',
    relatedTerms: ['SEC', '自主規制機関', '米国証券業協会 (SIAが前身の一つ)', '証券外務員登録']
  },
  // --- 経済学・金融工学基礎 (Economics & Financial Engineering Basics) ---
  {
    id: 251,
    term: '機会費用',
    category: '経済学・金融工学基礎',
    description: 'ある選択をした場合に、その選択によって諦めなければならなかった他の選択肢から得られたであろう最大の利益や価値のことです。経済学的な意思決定において、実際には支払われない費用（逸失利益）として考慮される重要な概念です。例えば、預金ではなく株式投資を選んだ場合、預金で得られたはずの利息が機会費用の一つとなります。',
    relatedTerms: ['トレードオフ', '選択理論', '費用便益分析', 'サンクコスト (埋没費用)', '経済的価値']
  },
  {
    id: 252,
    term: 'リスクプレミアム',
    category: '経済学・金融工学基礎',
    description: '投資家が、リスクのある資産（株式など）に投資する際に、リスクのない安全資産（国債など）の収益率（リスクフリーレート）に上乗せして要求する追加的な収益（リターン）のことです。リスクが高いほど、投資家はより高いリスクプレミアムを期待します。',
    relatedTerms: ['リスクフリーレート', '期待収益率', 'CAPM', 'β値 (ベータ値)', '市場リスク']
  },
  {
    id: 253,
    term: 'β値',
    category: '経済学・金融工学基礎',
    description: '個別の株式やポートフォリオの価格が、市場全体（例：TOPIXやS&P500などの株価指数）の値動きに対してどの程度敏感に反応するかを示す指標です。市場全体の値動きを1とした場合、β値が1より大きければ市場より値動きが大きく（ハイリスク・ハイリターン）、1より小さければ値動きが小さい（ローリスク・ローリターン）傾向があることを示します。',
    relatedTerms: ['α値 (アルファ値)', 'CAPM', '市場リスク', 'システマティックリスク', 'ポートフォリオ理論', '感応度']
  },
  {
    id: 254,
    term: 'α値',
    category: '経済学・金融工学基礎',
    description: '個別の株式やポートフォリオが、市場全体の動き（β値で説明される部分）から期待されるリターンに対して、どれだけ上回ったか（または下回ったか）を示す超過リターンのことです。ファンドマネージャーの運用手腕や、銘柄選択能力を評価する指標の一つとして用いられます。プラスのα値は市場平均を上回る運用成果を意味します。',
    relatedTerms: ['β値 (ベータ値)', 'CAPM', '超過リターン', 'アクティブ運用', 'ファンド評価', 'ジェンセンのアルファ']
  },
  {
    id: 255,
    term: 'シャープレシオ',
    category: '経済学・金融工学基礎',
    description: '投資のリスク（標準偏差やボラティリティ）1単位あたり、どれだけ効率的にリスクフリーレートを超えるリターン（超過リターン）を得られたかを示す投資効率の測定指標です。数値が高いほど、リスクに見合ったリターンを効率よく得ていると評価されます。異なる投資信託やポートフォリオの運用成績を比較する際に用いられます。',
    relatedTerms: ['ソルティノレシオ', '標準偏差', 'リスク調整後リターン', '超過リターン', 'リスクフリーレート', 'ポートフォリオ評価']
  },
  {
    id: 256,
    term: 'ソルティノレシオ',
    category: '経済学・金融工学基礎',
    description: 'シャープレシオと同様に投資効率を測る指標ですが、リスクとして価格の上昇変動（プラスのリターン）は考慮せず、価格の下落変動（マイナスのリターン、下方リスク）のみを対象とします。特に、リターンの下方リスクを重視する投資家にとって有用な指標とされています。',
    relatedTerms: ['シャープレシオ', '下方リスク', '標準偏差', 'リスク調整後リターン', '超過リターン']
  },
  {
    id: 257,
    term: 'CAPM',
    category: '経済学・金融工学基礎',
    description: '「資本資産価格モデル（キャップエム）」と訳されます。個別の株式などの危険資産（リスク資産）の期待収益率が、リスクフリーレート、市場全体の期待収益率、そしてその資産の市場に対する感応度（β値）によって決定されるとする理論モデルです。現代ポートフォリオ理論を基礎としています。',
    relatedTerms: ['β値 (ベータ値)', 'リスクプレミアム', '現代ポートフォリオ理論', '証券市場線', '期待収益率', '効率的フロンティア']
  },
  {
    id: 258,
    term: '効率的市場仮説',
    category: '経済学・金融工学基礎',
    description: '金融市場において、利用可能な全ての情報は即座に資産価格に織り込まれるため、常に適正な価格が形成されており、情報分析によって市場平均を上回るリターンを一貫して得ることはできないとする仮説です。仮説の強さによって「ウィーク型」「セミストロング型」「ストロング型」の3つに分類されます。',
    relatedTerms: ['ランダムウォーク理論', 'テクニカル分析 (の否定)', 'ファンダメンタルズ分析 (の限界)', 'インデックス投資', 'アノマリー', '行動ファイナンス (からの批判)']
  },
  {
    id: 259,
    term: '現代ポートフォリオ理論',
    category: '経済学・金融工学基礎',
    description: 'ハリー・マーコウィッツ氏によって提唱された、リスクとリターンの関係を数理的に分析し、与えられたリスク水準で最大のリターンを得る、あるいは与えられたリターン水準で最小のリスクとなるような最適な資産の組み合わせ（ポートフォリオ）を構築するための理論です。分散投資の重要性を示しました。',
    relatedTerms: ['ポートフォリオ', '分散投資', 'リスクとリターン', '効率的フロンティア', 'CAPM', 'ハリー・マーコウィッツ']
  },
  {
    id: 260,
    term: '行動ファイナンス',
    category: '経済学・金融工学基礎',
    description: '伝統的な経済学やファイナンス理論が前提とする「完全に合理的な投資家」像ではなく、人間の心理的な偏り（認知バイアス）や感情が、実際の投資判断や市場価格の形成にどのような影響を与えるかを研究する学問分野です。アノマリー現象などを説明する試みも行われます。',
    relatedTerms: ['プロスペクト理論', 'ハーディング効果', 'アノマリー', '効率的市場仮説 (への示唆)', '認知バイアス', '心理的会計']
  },
  {
    id: 261,
    term: 'プロスペクト理論',
    category: '経済学・金融工学基礎',
    description: 'ダニエル・カーネマン氏とエイモス・トベルスキー氏によって提唱された、不確実な状況下における人間の意思決定モデルです。人々は利益を得る場面ではリスク回避的になり、損失を被る場面ではリスク愛好的になる傾向があることや、損失の心理的影響が利益のそれよりも大きい（損失回避性）ことなどを示しました。行動ファイナンスの代表的な理論の一つです。',
    relatedTerms: ['行動ファイナンス', '損失回避性', '参照点依存性', '価値関数', '確率加重関数', 'ダニエル・カーネマン']
  },
  {
    id: 262,
    term: '裁定取引',
    category: '経済学・金融工学基礎',
    description: '同一の価値を持つ金融商品が、異なる市場で異なる価格で取引されている場合に、割安な市場で買い、割高な市場で売ることで、リスクなしに（または極めて低リスクで）利益を得ようとする取引のことです。「サヤ取り」とも言います。このような取引が行われることで、市場間の価格差は縮小し、価格の一致（一物一価の法則）が促されます。',
    relatedTerms: ['一物一価の法則', 'サヤ取り', '効率的市場仮説', 'プログラム売買', '金利裁定']
  },
  {
    id: 263,
    term: '複利',
    category: '経済学・金融工学基礎',
    description: '元本（当初の投資額）だけでなく、それによって得られた利子や収益も元本に組み入れ、その合計額に対してさらに利子や収益が計算される仕組みのことです。期間が長くなるほど、利子が利子を生む効果（雪だるま式）で資産が大きく増える可能性があります。「人類最大の発明」とアインシュタインが言ったとされることもあります。',
    relatedTerms: ['単利', '利息', '長期投資', '積立投資', '72の法則', '資産形成']
  },
  {
    id: 264,
    term: '単利',
    category: '経済学・金融工学基礎',
    description: '当初の元本に対してのみ利子が計算される仕組みのことです。複利とは異なり、途中で得られた利子は元本に組み入れられません。したがって、同じ利率・期間であれば、複利よりも最終的に得られる利息の総額は少なくなります。',
    relatedTerms: ['複利', '利息', '元本', '金利計算']
  },
  {
    id: 265,
    term: '現在価値',
    category: '経済学・金融工学基礎',
    description: '将来受け取ることができるお金やキャッシュフローが、現在の時点ではどれくらいの価値になるかを示したものです。将来のお金の価値を、一定の割引率（金利など）を使って現在の価値に割り戻して計算します。投資判断や企業価値評価（DCF法など）で重要な概念です。',
    relatedTerms: ['将来価値', '割引率', 'DCF法 (割引キャッシュフロー法)', '時間価値', '正味現在価値']
  },
  {
    id: 266,
    term: '将来価値',
    category: '経済学・金融工学基礎',
    description: '現在の一定額のお金やキャッシュフローが、一定の利率（運用利回りなど）で運用された場合に、将来の特定の時点ではどれくらいの価値になるかを示したものです。複利計算などで用いられます。',
    relatedTerms: ['現在価値', '割引率 (運用利回り)', '複利', '時間価値', '年金終価係数']
  },
  {
    id: 267,
    term: '割引率',
    category: '経済学・金融工学基礎',
    description: '将来のキャッシュフローの現在価値を計算する際に用いる利率のことです。投資のリスクや時間の経過によるお金の価値の変化を反映します。一般的には、リスクが高いほど高い割引率が適用され、現在価値は低くなります。企業価値評価ではWACC（加重平均資本コスト）などが用いられます。',
    relatedTerms: ['現在価値', 'WACC (加重平均資本コスト)', 'リスクフリーレート', 'リスクプレミアム', 'ハードルレート']
  },
  {
    id: 268,
    term: 'インフレリスク',
    category: '経済学・金融工学基礎',
    description: '物価が上昇（インフレーション）することによって、保有している現金の価値や、固定された利回りを持つ金融資産（預金や債券など）の実質的な価値が目減りしてしまうリスクのことです。「購買力リスク」とも言います。',
    relatedTerms: ['インフレーション', 'デフレーションリスク', '購買力', '実質金利', '資産防衛']
  },
  {
    id: 269,
    term: '為替リスク',
    category: '経済学・金融工学基礎',
    description: '外国の通貨建ての資産（外貨預金、外国株式、外国債券など）を保有している場合に、為替レートの変動によって、円換算した際の資産価値が変動するリスクのことです。円高になれば円換算価値は減少し、円安になれば増加します。',
    relatedTerms: ['為替レート', '円高', '円安', '外国為替証拠金取引', '為替ヘッジ', 'カントリーリスク']
  },
  {
    id: 270,
    term: '金利リスク',
    category: '経済学・金融工学基礎',
    description: '市場金利の変動によって、保有している債券などの金融商品の価格や価値が変動するリスクのことです。一般的に、市場金利が上昇すると債券価格は下落し、市場金利が低下すると債券価格は上昇します。特に固定利付債で影響が大きいです。',
    relatedTerms: ['債券価格', '市場金利', 'デュレーション', 'イールドカーブ', '固定利付債', '変動金利']
  },

  // --- 株式関連その他 ---
  {
    id: 271,
    term: '機関投資家',
    category: '株式関連その他',
    description: '生命保険会社、損害保険会社、信託銀行、年金基金、投資信託運用会社、ヘッジファンドなど、顧客から預かった巨額の資金を運用する法人投資家の総称です。その取引規模の大きさから、株式市場や債券市場に大きな影響力を持つ存在です。',
    relatedTerms: ['個人投資家', '外国人投資家', '年金基金 (GPIFなど)', '投資信託', '生命保険会社', 'アセットマネジメント会社', '大口投資家']
  },
  {
    id: 272,
    term: '個人投資家',
    category: '株式関連その他',
    description: '自己の資金で株式や投資信託などの金融商品に投資を行う個人のことです。機関投資家と対比される概念です。近年はインターネット証券の普及などにより、個人投資家の市場参加が増加しています。',
    relatedTerms: ['機関投資家', 'NISA', 'デイトレーダー', 'ネット証券', '株主優待']
  },
  {
    id: 273,
    term: '外国人投資家',
    category: '株式関連その他',
    description: '日本国外に居住する投資家（個人および機関投資家）のことです。日本の株式市場においては、売買シェアが非常に大きく、市場の動向に大きな影響を与える存在とされています。その動向は常に注目されます。',
    relatedTerms: ['機関投資家', '海外投資家', '投資主体別売買動向', 'グローバル市場', '円キャリートレード']
  },
  {
    id: 274,
    term: '仕手株',
    category: '株式関連その他',
    description: '特定の投資家グループ（仕手筋）が、意図的に株価を吊り上げるために大量の買い注文を入れたり、虚偽の情報を流布したりする対象となりやすい株式のことです。株価が短期間で急騰・急落を繰り返すことが多く、一般の投資家が手を出すと大きな損失を被る可能性があり、非常にリスクが高いです。',
    relatedTerms: ['投機的売買', '株価操縦', '風説の流布', '低位株', '品薄株', '提灯買い']
  },
  {
    id: 275,
    term: 'ボロ株',
    category: '株式関連その他',
    description: '株価が極めて低い水準（例えば数十円や数円）で取引されている株式の俗称です。「低位株」とも呼ばれます。業績不振や財務内容が悪化している企業の株式であることが多いですが、僅かな値動きでも変動率が大きくなるため、投機的な売買の対象となることもあります。',
    relatedTerms: ['低位株', '仕手株', '株価', '倒産リスク', '投機']
  },
  {
    id: 276,
    term: '材料株',
    category: '株式関連その他',
    description: '新製品の開発発表、業績予想の大幅な修正、M&A（合併・買収）の噂や決定、画期的な技術開発、大型受注など、株価に大きな影響を与える可能性のある特定の情報（材料）が出た、または出ると期待される企業の株式のことです。材料の内容によって株価が大きく変動しやすい傾向があります。',
    relatedTerms: ['テーマ株', '好材料', '悪材料', 'ニュースリリース', '思惑買い', 'カタリスト']
  },
  {
    id: 277,
    term: 'テーマ株',
    category: '株式関連その他',
    description: '特定の社会的関心事や経済的なトレンド（テーマ）に関連し、その恩恵を受けると期待される企業の株式群のことです。例えば、AI（人工知能）、再生可能エネルギー、デジタルトランスフォーメーション（DX）、メタバースなどがテーマとなり得ます。市場の注目が集まりやすく、株価が大きく動くことがあります。',
    relatedTerms: ['材料株', 'セクター', 'トレンド投資', 'AI関連株', 'ESG関連株', '国策銘柄']
  },
  {
    id: 278,
    term: 'ディフェンシブ銘柄',
    category: '株式関連その他',
    description: '景気の変動に業績が左右されにくいとされる業種（例：食品、医薬品、電力・ガス、鉄道など、生活必需品や社会インフラ関連）の株式のことです。不況時でも需要が比較的安定しているため、株価も景気後退局面に強い（ディフェンシブな）傾向があるとされます。ポートフォリオの安定性を高める目的で組み入れられることがあります。',
    relatedTerms: ['景気敏感株', '生活必需品セクター', '安定株', '不況抵抗株', '公益株', 'ポートフォリオ安定化']
  },
  {
    id: 279,
    term: '景気敏感株',
    category: '株式関連その他',
    description: '景気の変動によって業績や株価が大きく左右されやすい業種（例：鉄鋼、化学、機械、自動車、不動産、海運など、素材産業や設備投資関連、耐久消費財関連）の株式のことです。「シクリカル株」とも呼ばれます。好景気時には株価が大きく上昇しやすい一方、不況時には下落しやすい傾向があります。',
    relatedTerms: ['ディフェンシブ銘柄', 'シクリカル株', '景気循環', '素材株', '設備投資関連株', '好景気・不景気']
  },
  {
    id: 280,
    term: 'インカム投資',
    category: '株式関連その他',
    description: '株式の配当金、投資信託の分配金、債券の利子、不動産の賃料収入など、資産を保有することで定期的に得られる収益（インカムゲイン）を主な目的とする投資スタイルのことです。キャピタルゲイン（売買差益）狙いの投資と対比されます。安定的なキャッシュフローを重視する投資家に好まれます。',
    relatedTerms: ['インカムゲイン', 'キャピタルゲイン投資', '高配当株投資', '債券投資', '不動産投資', '安定運用']
  },
  {
    id: 281,
    term: 'キャピタルゲイン投資',
    category: '株式関連その他',
    description: '株式や不動産などの資産価格の上昇による売買差益（キャピタルゲイン）を主な目的とする投資スタイルのことです。「値上がり益狙い」とも言います。インカムゲイン（配当金など）狙いの投資と対比されます。成長株投資などが代表例です。',
    relatedTerms: ['キャピタルゲイン', 'インカム投資', '成長株投資', '値上がり益', '短期売買', 'グロース株']
  },
  {
    id: 282,
    term: 'テクニカル指標',
    category: '株式関連その他',
    description: '過去の株価や出来高などの市場データを基に、統計的な計算やパターン認識を用いて、将来の値動きを予測したり、売買のタイミングを判断したりするための指標の総称です。移動平均線、MACD、RSIなどが代表的です。テクニカル分析で利用されます。',
    relatedTerms: ['テクニカル分析', '移動平均線', 'MACD', 'RSI', 'チャート分析', 'オシレーター系', 'トレンド系']
  },
  {
    id: 283,
    term: 'ファンダメンタル指標',
    category: '株式関連その他',
    description: '企業の財務状況、業績、成長性など、企業の本質的な価値（ファンダメンタルズ）を評価するための指標の総称です。PER、PBR、ROE、EPSなどが代表的です。ファンダメンタルズ分析で利用され、株価の割安性や企業の収益性を判断するのに役立ちます。',
    relatedTerms: ['ファンダメンタルズ分析', 'PER', 'PBR', 'ROE', 'EPS', '財務指標', '企業価値評価']
  },
  {
    id: 284,
    term: '含み益',
    category: '株式関連その他',
    description: '保有している株式や投資信託などの金融資産の現在の時価が、取得時の価格（簿価）を上回っている場合の、まだ実現していない（売却して利益を確定していない）利益のことです。「評価益」とも言います。売却して初めて実際の利益（実現益）となります。',
    relatedTerms: ['含み損', '実現損益', '時価評価', '簿価', '評価益', '利益確定']
  },
  {
    id: 285,
    term: '含み損',
    category: '株式関連その他',
    description: '保有している株式や投資信託などの金融資産の現在の時価が、取得時の価格（簿価）を下回っている場合の、まだ実現していない（売却して損失を確定していない）損失のことです。「評価損」とも言います。売却して初めて実際の損失（実現損）となります。',
    relatedTerms: ['含み益', '実現損益', '時価評価', '簿価', '評価損', '損切り']
  },

  // --- その他一般用語 ---
  {
    id: 286,
    term: 'アセットマネジメント',
    category: 'その他一般用語',
    description: '「資産運用」または「資産管理」と訳されます。顧客（個人や機関投資家など）から預かった資産を、株式、債券、不動産、その他の金融商品などに投資し、その価値を維持・増加させることを目指す専門的な業務やサービスのことです。投資信託運用会社や信託銀行、投資顧問会社などが行います。',
    relatedTerms: ['ウェルスマネジメント', '投資信託', 'ファンドマネージャー', 'ポートフォリオ運用', '資産運用会社', '機関投資家']
  },
  {
    id: 287,
    term: 'ウェルスマネジメント',
    category: 'その他一般用語',
    description: '主に富裕層の個人顧客に対して、資産運用だけでなく、相続、事業承継、不動産、税務、ライフプランニングなど、資産に関する包括的なアドバイスやサービスを提供する業務のことです。アセットマネジメントよりも広範な領域をカバーします。',
    relatedTerms: ['アセットマネジメント', '富裕層ビジネス', 'プライベートバンク', 'ファイナンシャルプランナー', '資産承継']
  },
  {
    id: 288,
    term: 'ファイナンシャルプランナー',
    category: 'その他一般用語',
    description: '個人のライフプラン（夢や目標）を実現するために、顧客の収入、支出、資産、負債、保険などを総合的に分析し、貯蓄計画、投資計画、税金対策、不動産、相続・事業承継など、お金に関する包括的なアドバイスや実行支援を行う専門家です。CFP®やAFPなどの資格があります。',
    relatedTerms: ['ライフプランニング', '資産運用相談', 'CFP (国際CFP資格)', 'AFP (日本FP協会認定資格)', '独立系FP', '家計相談']
  },
  {
    id: 289,
    term: 'プライベートバンク',
    category: 'その他一般用語',
    description: '主に富裕層の個人顧客を対象として、資産運用、資産管理、相続・事業承継、不動産、税務、時には美術品管理や慈善活動支援など、オーダーメイドの包括的な金融サービスを提供する専門銀行または証券会社などの一部門です。守秘性が高く、顧客との長期的な信頼関係を重視します。',
    relatedTerms: ['ウェルスマネジメント', '富裕層', '資産管理', 'オーダーメイドサービス', 'スイス銀行 (イメージ)']
  },
  {
    id: 290,
    term: 'カストディアン',
    category: 'その他一般用語',
    description: '投資家に代わって有価証券（株式、債券など）の保管・管理、配当金や利息の受け取り、議決権行使の代行などを行う金融機関のことです。「保管受託機関」とも呼ばれます。主に信託銀行などがこの業務を担い、機関投資家や投資信託の資産管理を支えています。',
    relatedTerms: ['信託銀行', '資産管理', '証券保管振替制度', '機関投資家', '投資信託']
  },
  {
    id: 291,
    term: 'ブローカー',
    category: 'その他一般用語',
    description: '投資家（顧客）からの株式や債券、デリバティブなどの売買注文を受け付け、取引所や他の市場参加者に取り次ぐことを専門業務とする業者や個人のことです。顧客の注文を執行することで手数料（コミッション）を収益とします。自己の勘定（自己資金）で売買を行うディーラーとは区別されます。',
    relatedTerms: ['ディーラー', '証券会社', '委託売買', '手数料 (コミッション)', '注文執行', '仲介業者']
  },
  {
    id: 292,
    term: 'ディーラー',
    category: 'その他一般用語',
    description: '自己の勘定（自己資金）と責任において、株式や債券、為替などの金融商品を売買し、その差益を追求する業者や個人のことです。市場に流動性を提供する役割も担います（マーケットメイク）。顧客の注文を取り次ぐブローカーとは業務内容が異なります。銀行や証券会社のディーリング部門などがあります。',
    relatedTerms: ['ブローカー', '自己売買部門', 'マーケットメイク', '流動性供給', 'トレーダー']
  },
  {
    id: 293,
    term: 'マーケットメーカー',
    category: 'その他一般用語',
    description: '特定の金融商品について、常に売り気配と買い気配を提示し、投資家からの注文に応じることで市場に流動性を供給する役割を担う証券会社や金融機関のことです。取引を活発にし、価格形成を円滑にする機能があります。ETF市場などで重要な役割を果たします。',
    relatedTerms: ['流動性', '気配値', 'スプレッド', 'ディーラー', 'ETF', '造市業者']
  },
  {
    id: 294,
    term: 'ヘッジ取引',
    category: 'その他一般用語',
    description: '保有している資産の価格変動リスクや将来の不確実性から生じる損失の可能性を回避または軽減するために行う取引のことです。「リスクヘッジ」とほぼ同義です。例えば、保有株の値下がりリスクに対して先物を売る、為替変動リスクに対して為替予約をするなどの手法があります。',
    relatedTerms: ['リスクヘッジ', '分散投資', '先物取引', 'オプション取引', '為替予約', '保険']
  },
  {
    id: 295,
    term: '投機',
    category: 'その他一般用語',
    description: '短期的な価格変動を予測し、その差益を狙ってリスクを取る売買行為のことです。実需に基づかない、価格変動そのものを利益機会と捉える取引を指すことが多いです。市場に流動性をもたらす側面もありますが、過度な投機は市場の不安定化を招くこともあります。「投資」とは区別されることがあります。',
    relatedTerms: ['投資', 'デイトレード', 'スキャルピング', '短期売買', 'ハイリスク・ハイリターン', '市場の効率性']
  },
  {
    id: 296,
    term: '投資顧問会社',
    category: 'その他一般用語',
    description: '顧客に対して、投資に関する助言を行ったり、投資判断の全部または一部を委任されて運用を行ったりする会社のことです。金融商品取引法上の「投資助言・代理業」または「投資運用業」の登録が必要です。顧客の資産状況や投資目的に応じたサービスを提供します。',
    relatedTerms: ['投資助言業', '投資運用業', 'ラップ口座', 'ファンドラップ', '金融商品取引業者']
  },
  {
    id: 297,
    term: '流動性',
    category: 'その他一般用語',
    description: '金融資産や市場において、取引のしやすさ、つまり「どれだけ容易に、かつ不利な価格変動を伴わずに売買（換金）できるか」の度合いのことです。流動性が高いとは、取引量が多く、いつでも希望する価格に近い価格で速やかに売買できる状態を指します。流動性が低いと、売買が成立しにくかったり、大きな価格変動を伴ったりするリスクがあります。',
    relatedTerms: ['市場流動性', '流動性リスク', '出来高 (売買高)', '板が厚い/薄い', 'スプレッド', '換金性']
  },
  {
    id: 298,
    term: 'カウンターパーティーリスク',
    category: 'その他一般用語',
    description: '金融取引において、取引の相手方（カウンターパーティー）が経営破綻などの理由により、契約通りに債務を履行できなくなる（デフォルトする）ことによって損失を被るリスクのことです。「取引相手リスク」とも言います。店頭デリバティブ取引などで特に意識されます。',
    relatedTerms: ['信用リスク', 'デフォルトリスク', '店頭デリバティブ', '清算機関', 'システミックリスク']
  },
  {
    id: 299,
    term: 'デフォルトリスク',
    category: 'その他一般用語',
    description: '債券の発行体（国や企業など）や融資の借入人が、財政難や経営不振などの理由により、元本や利息の支払いを約束通りに行えなくなる（債務不履行＝デフォルトに陥る）可能性のことです。「信用リスク」とほぼ同義で使われ、債券投資における主要なリスクの一つです。格付けがこのリスクの度合いを示します。',
    relatedTerms: ['信用リスク', '債務不履行', '格付け', '債券投資', 'ジャンク債', 'カントリーリスク', '倒産リスク']
  },
  {
    id: 300,
    term: 'モラルハザード',
    category: 'その他一般用語',
    description: '「倫理観の欠如」や「道徳的危険」と訳されます。保険契約や金融システムなどにおいて、本来リスクを負うべき当事者が、何らかの仕組み（例：保険や政府保証）によってリスクから保護されることで、かえって行動が不注意になったり、より大きなリスクを取ったりするようになる問題のことです。金融危機の一因となることもあります。',
    relatedTerms: ['情報の非対称性', 'プリンシパル＝エージェント問題', '金融危機', '大きすぎて潰せない', '保険']
  },
];
